var items = {
  "block.minecraft.acacia_button": "Akācijas poga",
  "block.minecraft.acacia_door": "Akāciju durvis",
  "block.minecraft.acacia_fence": "Akācijas koka žogs",
  "block.minecraft.acacia_fence_gate": "Akācijas žoga vārti",
  "block.minecraft.acacia_hanging_sign": "Iekarināta akācijas zīme",
  "block.minecraft.acacia_leaves": "Akācijas lapas",
  "block.minecraft.acacia_log": "Akācijas baļķis",
  "block.minecraft.acacia_planks": "Akācijas dēļi",
  "block.minecraft.acacia_pressure_plate": "Akācijas spiediena plātne",
  "block.minecraft.acacia_sapling": "Akācijas stāds",
  "block.minecraft.acacia_shelf": "Akācijas plaukts",
  "block.minecraft.acacia_sign": "Akācijas zīme",
  "block.minecraft.acacia_slab": "Akācijas plāksne",
  "block.minecraft.acacia_stairs": "Akācijas kāpnes",
  "block.minecraft.acacia_trapdoor": "Akācijas lūka",
  "block.minecraft.acacia_wall_hanging_sign": "Iekarināta akācijas sienas zīme",
  "block.minecraft.acacia_wall_sign": "Akācijas sienas zīme",
  "block.minecraft.acacia_wood": "Akācijas koks",
  "block.minecraft.activator_rail": "Aktivatora sliedes",
  "block.minecraft.air": "Gaiss",
  "block.minecraft.allium": "Sīpols",
  "block.minecraft.amethyst_block": "Ametista bloks",
  "block.minecraft.amethyst_cluster": "Ametista kopa",
  "block.minecraft.ancient_debris": "Senie gruveši",
  "block.minecraft.andesite": "Andesīts",
  "block.minecraft.andesite_slab": "Andesīta plāksne",
  "block.minecraft.andesite_stairs": "Andesīta kāpnes",
  "block.minecraft.andesite_wall": "Andesīta mūris",
  "block.minecraft.anvil": "Lakta",
  "block.minecraft.attached_melon_stem": "Pievienots arbūza stumbrs",
  "block.minecraft.attached_pumpkin_stem": "Pievienots ķirbja stumbrs",
  "block.minecraft.azalea": "Acālija",
  "block.minecraft.azalea_leaves": "Acāliju lapas",
  "block.minecraft.azure_bluet": "Debeszilā rudzupuķe",
  "block.minecraft.bamboo": "Bambuss",
  "block.minecraft.bamboo_block": "Bambusa bloks",
  "block.minecraft.bamboo_button": "Bambusa poga",
  "block.minecraft.bamboo_door": "Bambusa durvis",
  "block.minecraft.bamboo_fence": "Bambusa sēta",
  "block.minecraft.bamboo_fence_gate": "Bambusa žoga vārti",
  "block.minecraft.bamboo_hanging_sign": "Iekarināta bambusa zīme",
  "block.minecraft.bamboo_mosaic": "Bambusa mozaīka",
  "block.minecraft.bamboo_mosaic_slab": "Bambusa mozaīkas plāksne",
  "block.minecraft.bamboo_mosaic_stairs": "Bambusa mozaīkas kāpnes",
  "block.minecraft.bamboo_planks": "Bambusa dēļi",
  "block.minecraft.bamboo_pressure_plate": "Bambusa spiediena plāksne",
  "block.minecraft.bamboo_sapling": "Bambusa dzinums",
  "block.minecraft.bamboo_shelf": "Bambusa plaukts",
  "block.minecraft.bamboo_sign": "Bambusa zīme",
  "block.minecraft.bamboo_slab": "Bambusa plāksne",
  "block.minecraft.bamboo_stairs": "Bambusa kāpnes",
  "block.minecraft.bamboo_trapdoor": "Bambusa lūka",
  "block.minecraft.bamboo_wall_hanging_sign": "Iekarināta bambusa sienas zīme",
  "block.minecraft.bamboo_wall_sign": "Bambusa sienas zīme",
  "block.minecraft.banner.base.black": "Pilnīgi melns laukums",
  "block.minecraft.banner.base.blue": "Pilnīgi zils laukums",
  "block.minecraft.banner.base.brown": "Pilnīgi brūns laukums",
  "block.minecraft.banner.base.cyan": "Pilnīgi ciāns laukums",
  "block.minecraft.banner.base.gray": "Pilnīgi pelēks laukums",
  "block.minecraft.banner.base.green": "Pilnīgi zaļš laukums",
  "block.minecraft.banner.base.light_blue": "Pilnīgi gaiši zils laukums",
  "block.minecraft.banner.base.light_gray": "Pilnīgi gaiši pelēks laukums",
  "block.minecraft.banner.base.lime": "Pilnīgi gaiši zaļš laukums",
  "block.minecraft.banner.base.magenta": "Pilnīgi fuksīns laukums",
  "block.minecraft.banner.base.orange": "Pilnīgi oranžs laukums",
  "block.minecraft.banner.base.pink": "Pilnīgi rozā laukums",
  "block.minecraft.banner.base.purple": "Pilnīgi violets laukums",
  "block.minecraft.banner.base.red": "Pilnīgi sarkans laukums",
  "block.minecraft.banner.base.white": "Pilnīgi balts laukums",
  "block.minecraft.banner.base.yellow": "Pilnīgi dzeltens laukums",
  "block.minecraft.banner.border.black": "Melna apmale",
  "block.minecraft.banner.border.blue": "Zila apmale",
  "block.minecraft.banner.border.brown": "Brūna apmale",
  "block.minecraft.banner.border.cyan": "Ciāna apmale",
  "block.minecraft.banner.border.gray": "Pelēka apmale",
  "block.minecraft.banner.border.green": "Zaļa apmale",
  "block.minecraft.banner.border.light_blue": "Gaiši zila apmale",
  "block.minecraft.banner.border.light_gray": "Gaiši pelēka apmale",
  "block.minecraft.banner.border.lime": "Gaiši zaļa apmale",
  "block.minecraft.banner.border.magenta": "Fuksīna apmale",
  "block.minecraft.banner.border.orange": "Oranža apmale",
  "block.minecraft.banner.border.pink": "Rozā apmale",
  "block.minecraft.banner.border.purple": "Violeta apmale",
  "block.minecraft.banner.border.red": "Sarkana apmale",
  "block.minecraft.banner.border.white": "Balta apmale",
  "block.minecraft.banner.border.yellow": "Dzeltena apmale",
  "block.minecraft.banner.bricks.black": "Melns mūrēts lauks",
  "block.minecraft.banner.bricks.blue": "Zils mūrēts lauks",
  "block.minecraft.banner.bricks.brown": "Brūns mūrēts lauks",
  "block.minecraft.banner.bricks.cyan": "Ciāns mūrēts lauks",
  "block.minecraft.banner.bricks.gray": "Pelēks mūrēts lauks",
  "block.minecraft.banner.bricks.green": "Zaļš mūrēts lauks",
  "block.minecraft.banner.bricks.light_blue": "Gaiši zils mūrēts lauks",
  "block.minecraft.banner.bricks.light_gray": "Gaiši pelēks mūrēts lauks",
  "block.minecraft.banner.bricks.lime": "Gaiši zaļš mūrēts lauks",
  "block.minecraft.banner.bricks.magenta": "Fuksīns mūrēts lauks",
  "block.minecraft.banner.bricks.orange": "Oranžs mūrēts lauks",
  "block.minecraft.banner.bricks.pink": "Rozā mūrēts lauks",
  "block.minecraft.banner.bricks.purple": "Violets mūrēts lauks",
  "block.minecraft.banner.bricks.red": "Sarkans mūrēts lauks",
  "block.minecraft.banner.bricks.white": "Balts mūrēts lauks",
  "block.minecraft.banner.bricks.yellow": "Dzeltens mūrēts lauks",
  "block.minecraft.banner.circle.black": "Melns riņķis",
  "block.minecraft.banner.circle.blue": "Zils riņķis",
  "block.minecraft.banner.circle.brown": "Brūns riņķis",
  "block.minecraft.banner.circle.cyan": "Ciāns riņķis",
  "block.minecraft.banner.circle.gray": "Pelēks riņķis",
  "block.minecraft.banner.circle.green": "Zaļš riņķis",
  "block.minecraft.banner.circle.light_blue": "Gaiši zils riņķis",
  "block.minecraft.banner.circle.light_gray": "Gaiši pelēks riņķis",
  "block.minecraft.banner.circle.lime": "Gaiši zaļš riņķis",
  "block.minecraft.banner.circle.magenta": "Fuksīns riņķis",
  "block.minecraft.banner.circle.orange": "Oranžs riņķis",
  "block.minecraft.banner.circle.pink": "Rozā riņķis",
  "block.minecraft.banner.circle.purple": "Violets disks",
  "block.minecraft.banner.circle.red": "Sarkans riņķis",
  "block.minecraft.banner.circle.white": "Balts riņķis",
  "block.minecraft.banner.circle.yellow": "Dzeltens riņķis",
  "block.minecraft.banner.creeper.black": "Melns creeper lādiņš",
  "block.minecraft.banner.creeper.blue": "Zils creeper lādiņš",
  "block.minecraft.banner.creeper.brown": "Brūns creeper lādiņš",
  "block.minecraft.banner.creeper.cyan": "Ciāns creeper lādiņš",
  "block.minecraft.banner.creeper.gray": "Pelēks creeper lādiņš",
  "block.minecraft.banner.creeper.green": "Zaļš creeper lādiņš",
  "block.minecraft.banner.creeper.light_blue": "Gaiši zils creeper lādiņš",
  "block.minecraft.banner.creeper.light_gray": "Gaiši pelēks creeper lādiņš",
  "block.minecraft.banner.creeper.lime": "Gaiši zaļš creeper lādiņš",
  "block.minecraft.banner.creeper.magenta": "Fuksīns creeper lādiņš",
  "block.minecraft.banner.creeper.orange": "Oranžs creeper lādiņš",
  "block.minecraft.banner.creeper.pink": "Rozā creeper lādiņš",
  "block.minecraft.banner.creeper.purple": "Violets creeper lādiņš",
  "block.minecraft.banner.creeper.red": "Sarkans creeper lādiņš",
  "block.minecraft.banner.creeper.white": "Balts creeper lādiņš",
  "block.minecraft.banner.creeper.yellow": "Dzeltens creeper lādiņš",
  "block.minecraft.banner.cross.black": "Melns diagonāls krusts",
  "block.minecraft.banner.cross.blue": "Zils diagonāls krusts",
  "block.minecraft.banner.cross.brown": "Brūns diagonāls krusts",
  "block.minecraft.banner.cross.cyan": "Ciāns diagonāls krusts",
  "block.minecraft.banner.cross.gray": "Pelēks diagonāls krusts",
  "block.minecraft.banner.cross.green": "Zaļš diagonāls krusts",
  "block.minecraft.banner.cross.light_blue": "Gaiši zils diagonāls krusts",
  "block.minecraft.banner.cross.light_gray": "Gaiši pelēks diagonāls krusts",
  "block.minecraft.banner.cross.lime": "Gaiši zaļš diagonāls krusts",
  "block.minecraft.banner.cross.magenta": "Fuksīns diagonāls krusts",
  "block.minecraft.banner.cross.orange": "Oranžs diagonāls krusts",
  "block.minecraft.banner.cross.pink": "Rozā diagonāls krusts",
  "block.minecraft.banner.cross.purple": "Violets diagonāls krusts",
  "block.minecraft.banner.cross.red": "Sarkans diagonāls krusts",
  "block.minecraft.banner.cross.white": "Balts diagonāls krusts",
  "block.minecraft.banner.cross.yellow": "Dzeltens diagonāls krusts",
  "block.minecraft.banner.curly_border.black": "Melna robota apmale",
  "block.minecraft.banner.curly_border.blue": "Zila robota apmale",
  "block.minecraft.banner.curly_border.brown": "Brūna robota apmale",
  "block.minecraft.banner.curly_border.cyan": "Ciāna robota apmale",
  "block.minecraft.banner.curly_border.gray": "Pelēka robota apmale",
  "block.minecraft.banner.curly_border.green": "Zaļa robota apmale",
  "block.minecraft.banner.curly_border.light_blue": "Gaiši zila robota apmale",
  "block.minecraft.banner.curly_border.light_gray": "Gaiši pelēka robota apmale",
  "block.minecraft.banner.curly_border.lime": "Gaiši zaļa robota apmale",
  "block.minecraft.banner.curly_border.magenta": "Fuksīna robota apmale",
  "block.minecraft.banner.curly_border.orange": "Oranža robota apmale",
  "block.minecraft.banner.curly_border.pink": "Rozā robota apmale",
  "block.minecraft.banner.curly_border.purple": "Violeta robota apmale",
  "block.minecraft.banner.curly_border.red": "Sarkana robota apmale",
  "block.minecraft.banner.curly_border.white": "Balta robota apmale",
  "block.minecraft.banner.curly_border.yellow": "Dzeltena robota apmale",
  "block.minecraft.banner.diagonal_left.black": "Melna kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.blue": "Zila kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.brown": "Brūna kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.cyan": "Ciāna kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.gray": "Pelēka kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.green": "Zaļa kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.light_blue": "Gaiši zila kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.light_gray": "Gaiši pelēka kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.lime": "Gaiši zaļa kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.magenta": "Fuksīna kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.orange": "Oranža kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.pink": "Rozā kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.purple": "Violeta kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.red": "Sarkana kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.white": "Balta kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_left.yellow": "Dzeltena kreisās diagonāles augša",
  "block.minecraft.banner.diagonal_right.black": "Melna diagonāles augša",
  "block.minecraft.banner.diagonal_right.blue": "Zila diagonāles augša",
  "block.minecraft.banner.diagonal_right.brown": "Brūna diagonāles augša",
  "block.minecraft.banner.diagonal_right.cyan": "Ciāna diagonāles augša",
  "block.minecraft.banner.diagonal_right.gray": "Pelēka diagonāles augša",
  "block.minecraft.banner.diagonal_right.green": "Zaļa diagonāles augša",
  "block.minecraft.banner.diagonal_right.light_blue": "Gaiši zila diagonāles augša",
  "block.minecraft.banner.diagonal_right.light_gray": "Gaiši pēlēka diagonāles augša",
  "block.minecraft.banner.diagonal_right.lime": "Gaiši zaļa diagonāles augša",
  "block.minecraft.banner.diagonal_right.magenta": "Fuksīna diagonāles augša",
  "block.minecraft.banner.diagonal_right.orange": "Oranža diagonāles augša",
  "block.minecraft.banner.diagonal_right.pink": "Rozā diagonāles augša",
  "block.minecraft.banner.diagonal_right.purple": "Violeta diagonāles augša",
  "block.minecraft.banner.diagonal_right.red": "Sarkana diagonāles augša",
  "block.minecraft.banner.diagonal_right.white": "Balta diagonāles augša",
  "block.minecraft.banner.diagonal_right.yellow": "Dzeltena diagonāles augša",
  "block.minecraft.banner.diagonal_up_left.black": "Melna diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.blue": "Zila diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.brown": "Brūna diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.cyan": "Ciāna diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.gray": "Pelēka diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.green": "Zaļa diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Gaiši zila diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Gaiši pelēka diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.lime": "Gaiši zaļa diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.magenta": "Fuksīna diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.orange": "Oranža diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.pink": "Rozā diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.purple": "Violeta diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.red": "Sarkana diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.white": "Balta diagonāles apakša",
  "block.minecraft.banner.diagonal_up_left.yellow": "Dzeltena diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.black": "Melna kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.blue": "Zila kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.brown": "Brūna kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.cyan": "Ciāna kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.gray": "Pelēka kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.green": "Zaļa kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Gaiši zila kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Gaiši pelēka kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.lime": "Gaiši zaļa kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.magenta": "Fuksīna kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.orange": "Oranža kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.pink": "Rozā kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.purple": "Violeta kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.red": "Sarkana kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.white": "Balta kreisās diagonāles apakša",
  "block.minecraft.banner.diagonal_up_right.yellow": "Dzeltena kreisās diagonāles apakša",
  "block.minecraft.banner.flow.black": "Melna plūsma",
  "block.minecraft.banner.flow.blue": "Zila plūsma",
  "block.minecraft.banner.flow.brown": "Brūna plūsma",
  "block.minecraft.banner.flow.cyan": "Ciāna plūsma",
  "block.minecraft.banner.flow.gray": "Pelēka plūsma",
  "block.minecraft.banner.flow.green": "Zaļa plūsma",
  "block.minecraft.banner.flow.light_blue": "Gaiši zila plūsma",
  "block.minecraft.banner.flow.light_gray": "Gaiši pelēka plūsma",
  "block.minecraft.banner.flow.lime": "Gaiši zaļa plūsma",
  "block.minecraft.banner.flow.magenta": "Fuksīna plūsma",
  "block.minecraft.banner.flow.orange": "Oranža plūsma",
  "block.minecraft.banner.flow.pink": "Rozā plūsma",
  "block.minecraft.banner.flow.purple": "Violeta plūsma",
  "block.minecraft.banner.flow.red": "Sarkana plūsma",
  "block.minecraft.banner.flow.white": "Balta plūsma",
  "block.minecraft.banner.flow.yellow": "Dzeltena plūsma",
  "block.minecraft.banner.flower.black": "Melns zieds",
  "block.minecraft.banner.flower.blue": "Zils zieds",
  "block.minecraft.banner.flower.brown": "Brūns zieds",
  "block.minecraft.banner.flower.cyan": "Ciāns zieds",
  "block.minecraft.banner.flower.gray": "Pelēks zieds",
  "block.minecraft.banner.flower.green": "Zaļš zieds",
  "block.minecraft.banner.flower.light_blue": "Gaiši zils zieds",
  "block.minecraft.banner.flower.light_gray": "Gaiši pelēks zieds",
  "block.minecraft.banner.flower.lime": "Gaiši zaļš zieds",
  "block.minecraft.banner.flower.magenta": "Fuksīns zieds",
  "block.minecraft.banner.flower.orange": "Oranžs zieds",
  "block.minecraft.banner.flower.pink": "Rozā zieds",
  "block.minecraft.banner.flower.purple": "Violets zieds",
  "block.minecraft.banner.flower.red": "Sarkans zieds",
  "block.minecraft.banner.flower.white": "Balts zieds",
  "block.minecraft.banner.flower.yellow": "Dzeltens zieds",
  "block.minecraft.banner.globe.black": "Melns globuss",
  "block.minecraft.banner.globe.blue": "Zils globuss",
  "block.minecraft.banner.globe.brown": "Brūns globuss",
  "block.minecraft.banner.globe.cyan": "Ciāns globuss",
  "block.minecraft.banner.globe.gray": "Pelēks globuss",
  "block.minecraft.banner.globe.green": "Zaļš globuss",
  "block.minecraft.banner.globe.light_blue": "Gaiši zils globuss",
  "block.minecraft.banner.globe.light_gray": "Gaiši pelēks globuss",
  "block.minecraft.banner.globe.lime": "Gaiši zaļš globuss",
  "block.minecraft.banner.globe.magenta": "Fuksīns globuss",
  "block.minecraft.banner.globe.orange": "Oranžs globuss",
  "block.minecraft.banner.globe.pink": "Rozā globuss",
  "block.minecraft.banner.globe.purple": "Violets globuss",
  "block.minecraft.banner.globe.red": "Sarkans globuss",
  "block.minecraft.banner.globe.white": "Balts globuss",
  "block.minecraft.banner.globe.yellow": "Dzeltens globuss",
  "block.minecraft.banner.gradient.black": "Melns gradients",
  "block.minecraft.banner.gradient.blue": "Zils gradients",
  "block.minecraft.banner.gradient.brown": "Brūns gradients",
  "block.minecraft.banner.gradient.cyan": "Ciāns gradients",
  "block.minecraft.banner.gradient.gray": "Pelēks gradients",
  "block.minecraft.banner.gradient.green": "Zaļš gradients",
  "block.minecraft.banner.gradient.light_blue": "Gaiši zils gradients",
  "block.minecraft.banner.gradient.light_gray": "Gaiši pelēks gradients",
  "block.minecraft.banner.gradient.lime": "Gaiši zaļš gradients",
  "block.minecraft.banner.gradient.magenta": "Fuksīns gradients",
  "block.minecraft.banner.gradient.orange": "Oranžs gradients",
  "block.minecraft.banner.gradient.pink": "Rozā gradients",
  "block.minecraft.banner.gradient.purple": "Violets gradients",
  "block.minecraft.banner.gradient.red": "Sarkans gradients",
  "block.minecraft.banner.gradient.white": "Balts gradients",
  "block.minecraft.banner.gradient.yellow": "Dzeltens gradients",
  "block.minecraft.banner.gradient_up.black": "Melns apakšējais gradients",
  "block.minecraft.banner.gradient_up.blue": "Zils apakšējais gradients",
  "block.minecraft.banner.gradient_up.brown": "Brūns apakšējais gradients",
  "block.minecraft.banner.gradient_up.cyan": "Ciāns apakšējais gradients",
  "block.minecraft.banner.gradient_up.gray": "Pelēks apakšējais gradients",
  "block.minecraft.banner.gradient_up.green": "Zaļš apakšējais gradients",
  "block.minecraft.banner.gradient_up.light_blue": "Gaiši zils apakšējais gradients",
  "block.minecraft.banner.gradient_up.light_gray": "Gaiši pelēks apakšējais gradients",
  "block.minecraft.banner.gradient_up.lime": "Gaiši zaļš apakšējais gradients",
  "block.minecraft.banner.gradient_up.magenta": "Fuksīns apakšējais gradients",
  "block.minecraft.banner.gradient_up.orange": "Oranžs apakšējais gradients",
  "block.minecraft.banner.gradient_up.pink": "Rozā apakšējais gradients",
  "block.minecraft.banner.gradient_up.purple": "Violets apakšējais gradients",
  "block.minecraft.banner.gradient_up.red": "Sarkans apakšējais gradients",
  "block.minecraft.banner.gradient_up.white": "Balts apakšējais gradients",
  "block.minecraft.banner.gradient_up.yellow": "Dzeltens apakšējais gradients",
  "block.minecraft.banner.guster.black": "Melna brāzma",
  "block.minecraft.banner.guster.blue": "Zila brāzma",
  "block.minecraft.banner.guster.brown": "Brūna brāzma",
  "block.minecraft.banner.guster.cyan": "Ciāna brāzma",
  "block.minecraft.banner.guster.gray": "Pelēka brāzma",
  "block.minecraft.banner.guster.green": "Zaļa brāzma",
  "block.minecraft.banner.guster.light_blue": "Gaiši zila brāzma",
  "block.minecraft.banner.guster.light_gray": "Gaiši pelēka brāzma",
  "block.minecraft.banner.guster.lime": "Gaiši zaļa brāzma",
  "block.minecraft.banner.guster.magenta": "Fuksīna brāzma",
  "block.minecraft.banner.guster.orange": "Oranža brāzma",
  "block.minecraft.banner.guster.pink": "Rozā brāzma",
  "block.minecraft.banner.guster.purple": "Violeta brāzma",
  "block.minecraft.banner.guster.red": "Sarkana brāzma",
  "block.minecraft.banner.guster.white": "Balta brāzma",
  "block.minecraft.banner.guster.yellow": "Dzeltena brāzma",
  "block.minecraft.banner.half_horizontal.black": "Melna augšdaļa",
  "block.minecraft.banner.half_horizontal.blue": "Zila augšdaļa",
  "block.minecraft.banner.half_horizontal.brown": "Brūna augšdaļa",
  "block.minecraft.banner.half_horizontal.cyan": "Ciāna augšdaļa",
  "block.minecraft.banner.half_horizontal.gray": "Pelēka augšdaļa",
  "block.minecraft.banner.half_horizontal.green": "Zaļa augšdaļa",
  "block.minecraft.banner.half_horizontal.light_blue": "Gaiši zila augšdaļa",
  "block.minecraft.banner.half_horizontal.light_gray": "Gaiši pelēka augšdaļa",
  "block.minecraft.banner.half_horizontal.lime": "Gaiši zaļa augšdaļa",
  "block.minecraft.banner.half_horizontal.magenta": "Fuksīna augšdaļa",
  "block.minecraft.banner.half_horizontal.orange": "Oranža augšdaļa",
  "block.minecraft.banner.half_horizontal.pink": "Rozā augšdaļa",
  "block.minecraft.banner.half_horizontal.purple": "Violeta augšdaļa",
  "block.minecraft.banner.half_horizontal.red": "Sarkana augšdaļa",
  "block.minecraft.banner.half_horizontal.white": "Balta augšdaļa",
  "block.minecraft.banner.half_horizontal.yellow": "Dzeltena augšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.black": "Melna apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Zila apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Brūna apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Ciāna apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Pelēka apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.green": "Zaļa apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Gaiši zila apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Gaiši pelēka apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Gaiši zaļa apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Fuksīna apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Oranža apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Rozā apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Violeta apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.red": "Sarkana apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.white": "Balta apakšdaļa",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Dzeltena apakšdaļa",
  "block.minecraft.banner.half_vertical.black": "Melna kreisā puse",
  "block.minecraft.banner.half_vertical.blue": "Zila kreisā puse",
  "block.minecraft.banner.half_vertical.brown": "Brūna kreisā puse",
  "block.minecraft.banner.half_vertical.cyan": "Ciāna kreisā puse",
  "block.minecraft.banner.half_vertical.gray": "Pelēka kreisā puse",
  "block.minecraft.banner.half_vertical.green": "Zaļa kreisā puse",
  "block.minecraft.banner.half_vertical.light_blue": "Gaiši zila kreisā puse",
  "block.minecraft.banner.half_vertical.light_gray": "Gaiši pelēka kreisā puse",
  "block.minecraft.banner.half_vertical.lime": "Gaiši zaļa kreisā puse",
  "block.minecraft.banner.half_vertical.magenta": "Fuksīna kreisā puse",
  "block.minecraft.banner.half_vertical.orange": "Oranža kreisā puse",
  "block.minecraft.banner.half_vertical.pink": "Rozā kreisā puse",
  "block.minecraft.banner.half_vertical.purple": "Violeta kreisā puse",
  "block.minecraft.banner.half_vertical.red": "Sarkana kreisā puse",
  "block.minecraft.banner.half_vertical.white": "Balta kreisā puse",
  "block.minecraft.banner.half_vertical.yellow": "Dzeltena kreisā puse",
  "block.minecraft.banner.half_vertical_right.black": "Melna labā puse",
  "block.minecraft.banner.half_vertical_right.blue": "Zila labā puse",
  "block.minecraft.banner.half_vertical_right.brown": "Brūna labā puse",
  "block.minecraft.banner.half_vertical_right.cyan": "Ciāna labā puse",
  "block.minecraft.banner.half_vertical_right.gray": "Pelēka labā puse",
  "block.minecraft.banner.half_vertical_right.green": "Zaļa labā puse",
  "block.minecraft.banner.half_vertical_right.light_blue": "Gaiši zila labā puse",
  "block.minecraft.banner.half_vertical_right.light_gray": "Gaiši pelēka labā puse",
  "block.minecraft.banner.half_vertical_right.lime": "Gaiši zaļa labā puse",
  "block.minecraft.banner.half_vertical_right.magenta": "Fuksīna labā puse",
  "block.minecraft.banner.half_vertical_right.orange": "Oranža labā puse",
  "block.minecraft.banner.half_vertical_right.pink": "Rozā labā puse",
  "block.minecraft.banner.half_vertical_right.purple": "Violeta labā puse",
  "block.minecraft.banner.half_vertical_right.red": "Sarkana labā puse",
  "block.minecraft.banner.half_vertical_right.white": "Balta labā puse",
  "block.minecraft.banner.half_vertical_right.yellow": "Dzeltena labā puse",
  "block.minecraft.banner.mojang.black": "Melna lieta",
  "block.minecraft.banner.mojang.blue": "Zila lieta",
  "block.minecraft.banner.mojang.brown": "Brūna lieta",
  "block.minecraft.banner.mojang.cyan": "Ciāna lieta",
  "block.minecraft.banner.mojang.gray": "Pelēka lieta",
  "block.minecraft.banner.mojang.green": "Zaļa lieta",
  "block.minecraft.banner.mojang.light_blue": "Gaiši zila lieta",
  "block.minecraft.banner.mojang.light_gray": "Gaiši pelēka lieta",
  "block.minecraft.banner.mojang.lime": "Gaiši zaļa lieta",
  "block.minecraft.banner.mojang.magenta": "Fuksīna lieta",
  "block.minecraft.banner.mojang.orange": "Oranža lieta",
  "block.minecraft.banner.mojang.pink": "Rozā lieta",
  "block.minecraft.banner.mojang.purple": "Vielota lieta",
  "block.minecraft.banner.mojang.red": "Sarkana lieta",
  "block.minecraft.banner.mojang.white": "Balta lieta",
  "block.minecraft.banner.mojang.yellow": "Dzeltena lieta",
  "block.minecraft.banner.piglin.black": "Melns šņukurs",
  "block.minecraft.banner.piglin.blue": "Zils šņukurs",
  "block.minecraft.banner.piglin.brown": "Brūns šņukurs",
  "block.minecraft.banner.piglin.cyan": "Ciāna šņukurs",
  "block.minecraft.banner.piglin.gray": "Pelēks šņukurs",
  "block.minecraft.banner.piglin.green": "Zaļš šņukurs",
  "block.minecraft.banner.piglin.light_blue": "Gaiši zils šņukurs",
  "block.minecraft.banner.piglin.light_gray": "Gaiši pelēks šņukurs",
  "block.minecraft.banner.piglin.lime": "Koši zaļš šņukurs",
  "block.minecraft.banner.piglin.magenta": "Fuksīns šņukurs",
  "block.minecraft.banner.piglin.orange": "Oranžs šņukurs",
  "block.minecraft.banner.piglin.pink": "Rozā šņukurs",
  "block.minecraft.banner.piglin.purple": "Violets šņukurs",
  "block.minecraft.banner.piglin.red": "Sarkans šņukurs",
  "block.minecraft.banner.piglin.white": "Balts šņukurs",
  "block.minecraft.banner.piglin.yellow": "Dzeltens šņukurs",
  "block.minecraft.banner.rhombus.black": "Melns rombs",
  "block.minecraft.banner.rhombus.blue": "Zils rombs",
  "block.minecraft.banner.rhombus.brown": "Brūns rombs",
  "block.minecraft.banner.rhombus.cyan": "Ciāns rombs",
  "block.minecraft.banner.rhombus.gray": "Pelēks rombs",
  "block.minecraft.banner.rhombus.green": "Zaļs rombs",
  "block.minecraft.banner.rhombus.light_blue": "Gaiši zils rombs",
  "block.minecraft.banner.rhombus.light_gray": "Gaiši pelēks rombs",
  "block.minecraft.banner.rhombus.lime": "Gaiši zaļš rombs",
  "block.minecraft.banner.rhombus.magenta": "Fuksīns rombs",
  "block.minecraft.banner.rhombus.orange": "Oranžs rombs",
  "block.minecraft.banner.rhombus.pink": "Rozā rombs",
  "block.minecraft.banner.rhombus.purple": "Violets rombs",
  "block.minecraft.banner.rhombus.red": "Sarkans rombs",
  "block.minecraft.banner.rhombus.white": "Balts rombs",
  "block.minecraft.banner.rhombus.yellow": "Dzeltens rombs",
  "block.minecraft.banner.skull.black": "Melns galvaskauss",
  "block.minecraft.banner.skull.blue": "Zils galvaskauss",
  "block.minecraft.banner.skull.brown": "Brūns galvaskauss",
  "block.minecraft.banner.skull.cyan": "Ciāns galvaskauss",
  "block.minecraft.banner.skull.gray": "Pelēks galvaskauss",
  "block.minecraft.banner.skull.green": "Zaļš galvaskauss",
  "block.minecraft.banner.skull.light_blue": "Gaiši zils galvaskauss",
  "block.minecraft.banner.skull.light_gray": "Gaiši pelēks galvaskauss",
  "block.minecraft.banner.skull.lime": "Gaiši zaļš galvaskauss",
  "block.minecraft.banner.skull.magenta": "Fuksīns galvaskauss",
  "block.minecraft.banner.skull.orange": "Oranžs galvaskauss",
  "block.minecraft.banner.skull.pink": "Rozā galvaskauss",
  "block.minecraft.banner.skull.purple": "Violets galvaskauss",
  "block.minecraft.banner.skull.red": "Sarkans galvaskauss",
  "block.minecraft.banner.skull.white": "Balts galvaskauss",
  "block.minecraft.banner.skull.yellow": "Dzeltens galvaskauss",
  "block.minecraft.banner.small_stripes.black": "Melnas vertikālas svītras",
  "block.minecraft.banner.small_stripes.blue": "Zilas vertikālas svītras",
  "block.minecraft.banner.small_stripes.brown": "Brūnas vertikālas svītras",
  "block.minecraft.banner.small_stripes.cyan": "Ciānas vertikālas svītras",
  "block.minecraft.banner.small_stripes.gray": "Pelēkas vertikālas svītras",
  "block.minecraft.banner.small_stripes.green": "Zaļas vertikālas svītras",
  "block.minecraft.banner.small_stripes.light_blue": "Gaiši zilas vertikālas svītras",
  "block.minecraft.banner.small_stripes.light_gray": "Gaiši pelēkas vertikālas svītras",
  "block.minecraft.banner.small_stripes.lime": "Gaiši zaļas vertikālas svītras",
  "block.minecraft.banner.small_stripes.magenta": "Fuksīnsas vertikālas svītras",
  "block.minecraft.banner.small_stripes.orange": "Oranžas vertikālas svītras",
  "block.minecraft.banner.small_stripes.pink": "Rozā vertikālas svītras",
  "block.minecraft.banner.small_stripes.purple": "Violetas vertikālas svītras",
  "block.minecraft.banner.small_stripes.red": "Sarkanas vertikālas svītras",
  "block.minecraft.banner.small_stripes.white": "Baltas vertikālas svītras",
  "block.minecraft.banner.small_stripes.yellow": "Dzeltenas vertikālas svītras",
  "block.minecraft.banner.square_bottom_left.black": "Melns kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.blue": "Zils kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.brown": "Brūns kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.cyan": "Ciāns kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.gray": "Pelēks kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.green": "Zaļš kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.light_blue": "Gaiši zils kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.light_gray": "Gaiši pelēks kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.lime": "Gaiži zaļš kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.magenta": "Fuksīns kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.orange": "Oranžs kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.pink": "Rozā kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.purple": "Vieloets bāzes kreisais stūris",
  "block.minecraft.banner.square_bottom_left.red": "Sarkans kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.white": "Balts kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_left.yellow": "Dzeltens kreisais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.black": "Melns labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.blue": "Zils labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.brown": "Brūns labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.cyan": "Ciās labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.gray": "Pelēks labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.green": "Zaļš labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.light_blue": "Gaiši zils labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.light_gray": "Gaiši pelēks labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.lime": "Gaiži zaļš labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.magenta": "Fuksīns vāzes labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.orange": "Oranžs labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.pink": "Rozā labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.purple": "Violets labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.red": "Sarkans labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.white": "Balts labais apakšējais stūris",
  "block.minecraft.banner.square_bottom_right.yellow": "Dzeltens labais apakšējais stūris",
  "block.minecraft.banner.square_top_left.black": "Melns kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.blue": "Zils kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.brown": "Brūns kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.cyan": "Ciāns kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.gray": "Pelēks kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.green": "Zaļš kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.light_blue": "Gaiši zils kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.light_gray": "Gaiši pelēks kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.lime": "Gaiši zaļš kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.magenta": "Fuksīns kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.orange": "Oranžs kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.pink": "Rozā kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.purple": "Violets kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.red": "Sarkans kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.white": "Balts kreisais augšējais stūris",
  "block.minecraft.banner.square_top_left.yellow": "Dzeltens kreisais augšējais stūris",
  "block.minecraft.banner.square_top_right.black": "Melns labais augšējais stūris",
  "block.minecraft.banner.square_top_right.blue": "Zils labais augšējais stūris",
  "block.minecraft.banner.square_top_right.brown": "Brūns labais augšējais stūris",
  "block.minecraft.banner.square_top_right.cyan": "Ciāns labais augšējais stūris",
  "block.minecraft.banner.square_top_right.gray": "Pelēks labais augšējais stūris",
  "block.minecraft.banner.square_top_right.green": "Zaļš labais augšējais stūris",
  "block.minecraft.banner.square_top_right.light_blue": "Gaiši zils labais augšējais stūris",
  "block.minecraft.banner.square_top_right.light_gray": "Gaiši pelēks labais augšējais stūris",
  "block.minecraft.banner.square_top_right.lime": "Gaiši zaļš labais augšējais stūris",
  "block.minecraft.banner.square_top_right.magenta": "Fuksīns labais augšējais stūris",
  "block.minecraft.banner.square_top_right.orange": "Oranžs labais augšējais stūris",
  "block.minecraft.banner.square_top_right.pink": "Rozā labais augšējais stūris",
  "block.minecraft.banner.square_top_right.purple": "Violets labais augšējais stūris",
  "block.minecraft.banner.square_top_right.red": "Sarkans labais augšējais stūris",
  "block.minecraft.banner.square_top_right.white": "Balts labais augšējais stūris",
  "block.minecraft.banner.square_top_right.yellow": "Dzeltens labais augšējais stūris",
  "block.minecraft.banner.straight_cross.black": "Melns krusts",
  "block.minecraft.banner.straight_cross.blue": "Zils krusts",
  "block.minecraft.banner.straight_cross.brown": "Brūns krusts",
  "block.minecraft.banner.straight_cross.cyan": "Ciāns krusts",
  "block.minecraft.banner.straight_cross.gray": "Pelēks krusts",
  "block.minecraft.banner.straight_cross.green": "Zaļš krusts",
  "block.minecraft.banner.straight_cross.light_blue": "Gaiši zils krusts",
  "block.minecraft.banner.straight_cross.light_gray": "Gaiši pelēks krusts",
  "block.minecraft.banner.straight_cross.lime": "Gaiši zaļš krusts",
  "block.minecraft.banner.straight_cross.magenta": "Fuksīns krusts",
  "block.minecraft.banner.straight_cross.orange": "Oranžs krusts",
  "block.minecraft.banner.straight_cross.pink": "Rozā krusts",
  "block.minecraft.banner.straight_cross.purple": "Violets krusts",
  "block.minecraft.banner.straight_cross.red": "Sarkans krusts",
  "block.minecraft.banner.straight_cross.white": "Balts krusts",
  "block.minecraft.banner.straight_cross.yellow": "Dzeltens krusts",
  "block.minecraft.banner.stripe_bottom.black": "Melna apakšmala",
  "block.minecraft.banner.stripe_bottom.blue": "Zila apakšmala",
  "block.minecraft.banner.stripe_bottom.brown": "Brūna apakšmala",
  "block.minecraft.banner.stripe_bottom.cyan": "Ciāna apakšmala",
  "block.minecraft.banner.stripe_bottom.gray": "Pelēka apakšmala",
  "block.minecraft.banner.stripe_bottom.green": "Zaļa apakšmala",
  "block.minecraft.banner.stripe_bottom.light_blue": "Gaiši zila apakšmala",
  "block.minecraft.banner.stripe_bottom.light_gray": "Gaiši pelēka apakšmala",
  "block.minecraft.banner.stripe_bottom.lime": "Gaiši zaļa apakšmala",
  "block.minecraft.banner.stripe_bottom.magenta": "Fuksīna apakšmala",
  "block.minecraft.banner.stripe_bottom.orange": "Oranža apakšmala",
  "block.minecraft.banner.stripe_bottom.pink": "Rozā apakšmala",
  "block.minecraft.banner.stripe_bottom.purple": "Violeta apakšmala",
  "block.minecraft.banner.stripe_bottom.red": "Sarkana apakšmala",
  "block.minecraft.banner.stripe_bottom.white": "Balta apakšmala",
  "block.minecraft.banner.stripe_bottom.yellow": "Dzeltena apakšmala",
  "block.minecraft.banner.stripe_center.black": "Melna vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.blue": "Zila vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.brown": "Brūna vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.cyan": "Ciāna vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.gray": "Pelēka vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.green": "Zaļa vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.light_blue": "Gaiši zila vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.light_gray": "Gaiši pelēka vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.lime": "Gaiši zaļa vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.magenta": "Fuksīna vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.orange": "Oranža vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.pink": "Rozā vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.purple": "Violeta vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.red": "Sarkana vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.white": "Balta vertikāla viduslīnija",
  "block.minecraft.banner.stripe_center.yellow": "Dzeltena vertikāla viduslīnija",
  "block.minecraft.banner.stripe_downleft.black": "Melna kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.blue": "Zila kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.brown": "Brūna kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.cyan": "Ciāna kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.gray": "Pelēka kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.green": "Zaļa kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.light_blue": "Gaiši zila kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.light_gray": "Gaiši pelēka kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.lime": "Gaiši zaļa kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.magenta": "Fuksīna kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.orange": "Oranža kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.pink": "Rozā kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.purple": "Violeta kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.red": "Sarkana kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.white": "Balta kreisā diagonāle",
  "block.minecraft.banner.stripe_downleft.yellow": "Dzeltena kreisā diagonāle",
  "block.minecraft.banner.stripe_downright.black": "Melna diagonāle",
  "block.minecraft.banner.stripe_downright.blue": "Zila diagonāle",
  "block.minecraft.banner.stripe_downright.brown": "Brūna diagonāle",
  "block.minecraft.banner.stripe_downright.cyan": "Ciāna diagonāle",
  "block.minecraft.banner.stripe_downright.gray": "Pelēka diagonāle",
  "block.minecraft.banner.stripe_downright.green": "Zaļa diagonāle",
  "block.minecraft.banner.stripe_downright.light_blue": "Gaiši zila diagonāle",
  "block.minecraft.banner.stripe_downright.light_gray": "Gaiši pelēka diagonāle",
  "block.minecraft.banner.stripe_downright.lime": "Gaiši zaļa diagonāle",
  "block.minecraft.banner.stripe_downright.magenta": "Fuksīna diagonāle",
  "block.minecraft.banner.stripe_downright.orange": "Oranža diagonāle",
  "block.minecraft.banner.stripe_downright.pink": "Roza diagonāle",
  "block.minecraft.banner.stripe_downright.purple": "Violeta diagonāle",
  "block.minecraft.banner.stripe_downright.red": "Sarkana diagonāle",
  "block.minecraft.banner.stripe_downright.white": "Balta diagonāle",
  "block.minecraft.banner.stripe_downright.yellow": "Dzeltena diagonāle",
  "block.minecraft.banner.stripe_left.black": "Melna kreisā mala",
  "block.minecraft.banner.stripe_left.blue": "Zila kreisā mala",
  "block.minecraft.banner.stripe_left.brown": "Brūna kreisā mala",
  "block.minecraft.banner.stripe_left.cyan": "Ciāna kreisā mala",
  "block.minecraft.banner.stripe_left.gray": "Pelēka kreisā mala",
  "block.minecraft.banner.stripe_left.green": "Zaļa kreisā mala",
  "block.minecraft.banner.stripe_left.light_blue": "Gaiši zila kreisā mala",
  "block.minecraft.banner.stripe_left.light_gray": "Gaiši pelēka kreisā mala",
  "block.minecraft.banner.stripe_left.lime": "Gaiši zaļa kreisā mala",
  "block.minecraft.banner.stripe_left.magenta": "Fuksīna kreisā mala",
  "block.minecraft.banner.stripe_left.orange": "Oranža kreisā mala",
  "block.minecraft.banner.stripe_left.pink": "Rozā kreisā mala",
  "block.minecraft.banner.stripe_left.purple": "Violeta kreisā mala",
  "block.minecraft.banner.stripe_left.red": "Sarkana kreisā mala",
  "block.minecraft.banner.stripe_left.white": "Balta kreisā mala",
  "block.minecraft.banner.stripe_left.yellow": "Dzeltena kreisā mala",
  "block.minecraft.banner.stripe_middle.black": "Melna horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.blue": "Zila horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.brown": "Brūna horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.cyan": "Ciāna horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.gray": "Pelēka horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.green": "Zaļa horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.light_blue": "Gaiši zila horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.light_gray": "Gaiši pelēka horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.lime": "Gaiši zaļa horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.magenta": "Fuksīna horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.orange": "Oranža horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.pink": "Rozā horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.purple": "Violeta horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.red": "Sarkana horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.white": "Balta horizontāla viduslīnija",
  "block.minecraft.banner.stripe_middle.yellow": "Dzeltena horizontāla viduslīnija",
  "block.minecraft.banner.stripe_right.black": "Melna labā mala",
  "block.minecraft.banner.stripe_right.blue": "Zila labā mala",
  "block.minecraft.banner.stripe_right.brown": "Brūna labā mala",
  "block.minecraft.banner.stripe_right.cyan": "Ciāna labā mala",
  "block.minecraft.banner.stripe_right.gray": "Pelēka labā mala",
  "block.minecraft.banner.stripe_right.green": "Zaļa labā mala",
  "block.minecraft.banner.stripe_right.light_blue": "Gaiši zila labā mala",
  "block.minecraft.banner.stripe_right.light_gray": "Gaiši pelēka labā mala",
  "block.minecraft.banner.stripe_right.lime": "Gaiši zaļa labā mala",
  "block.minecraft.banner.stripe_right.magenta": "Fuksīna labā mala",
  "block.minecraft.banner.stripe_right.orange": "Oranža labā mala",
  "block.minecraft.banner.stripe_right.pink": "Rozā labā mala",
  "block.minecraft.banner.stripe_right.purple": "Violeta labā mala",
  "block.minecraft.banner.stripe_right.red": "Sarkana labā mala",
  "block.minecraft.banner.stripe_right.white": "Balta labā mala",
  "block.minecraft.banner.stripe_right.yellow": "Dzeltena labā mala",
  "block.minecraft.banner.stripe_top.black": "Melna augšmala",
  "block.minecraft.banner.stripe_top.blue": "Zila augšmala",
  "block.minecraft.banner.stripe_top.brown": "Brūna augšmala",
  "block.minecraft.banner.stripe_top.cyan": "Ciāna augšmala",
  "block.minecraft.banner.stripe_top.gray": "Pelēka augšmala",
  "block.minecraft.banner.stripe_top.green": "Zaļa augšmala",
  "block.minecraft.banner.stripe_top.light_blue": "Gaiši zila augšmala",
  "block.minecraft.banner.stripe_top.light_gray": "Gaiši pelēka augšmala",
  "block.minecraft.banner.stripe_top.lime": "Gaiši zaļa augšmala",
  "block.minecraft.banner.stripe_top.magenta": "Fuksīna augšmala",
  "block.minecraft.banner.stripe_top.orange": "Oranža augšmala",
  "block.minecraft.banner.stripe_top.pink": "Rozā augšmala",
  "block.minecraft.banner.stripe_top.purple": "Violeta augšmala",
  "block.minecraft.banner.stripe_top.red": "Sarkana augšmala",
  "block.minecraft.banner.stripe_top.white": "Balta augšmala",
  "block.minecraft.banner.stripe_top.yellow": "Dzeltena augšmala",
  "block.minecraft.banner.triangle_bottom.black": "Melns apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.blue": "Zils apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.brown": "Brūns apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.cyan": "Ciāns apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.gray": "Pelēks apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.green": "Zaļš apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.light_blue": "Gaiši zils apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.light_gray": "Gaiši pelēks apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.lime": "Gaiši zaļš apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.magenta": "Fuksīns apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.orange": "Oranžs apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.pink": "Rozā apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.purple": "Violets apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.red": "Sarkans apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.white": "Balts apakšējais trīsstūris",
  "block.minecraft.banner.triangle_bottom.yellow": "Dzeltens apakšējais trīsstūris",
  "block.minecraft.banner.triangle_top.black": "Melns augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.blue": "Zils augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.brown": "Brūns augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.cyan": "Ciāns augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.gray": "Pelēks augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.green": "Zaļš augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.light_blue": "Gaiši zils augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.light_gray": "Gaiši pelēks augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.lime": "Gaiši zaļš augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.magenta": "Fuksīns augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.orange": "Oranžs augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.pink": "Rozā augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.purple": "Violets augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.red": "Sarkans augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.white": "Balts augšējais trīsstūris",
  "block.minecraft.banner.triangle_top.yellow": "Dzeltens augšējais trīsstūris",
  "block.minecraft.banner.triangles_bottom.black": "Melns apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.blue": "Zils apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.brown": "Brūns apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.cyan": "Ciāns apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.gray": "Pelēks apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.green": "Zaļš apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.light_blue": "Gaiši zils apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.light_gray": "Gaiši pelēks apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.lime": "Gaiši zaļš apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.magenta": "Fuksīns apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.orange": "Oranžs apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.pink": "Rozā apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.purple": "Violets apakšējais trīsstūris",
  "block.minecraft.banner.triangles_bottom.red": "Sarkans apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.white": "Balts apakšējais robojums",
  "block.minecraft.banner.triangles_bottom.yellow": "Dzeltens apakšējais robojums",
  "block.minecraft.banner.triangles_top.black": "Melns augšējais robojums",
  "block.minecraft.banner.triangles_top.blue": "Zils augšējais robojums",
  "block.minecraft.banner.triangles_top.brown": "Brūns augšējais robojums",
  "block.minecraft.banner.triangles_top.cyan": "Ciāns augšējais robojums",
  "block.minecraft.banner.triangles_top.gray": "Pelēks augšējais robojums",
  "block.minecraft.banner.triangles_top.green": "Zaļš augšējais robojums",
  "block.minecraft.banner.triangles_top.light_blue": "Gaiši zils augšējais robojums",
  "block.minecraft.banner.triangles_top.light_gray": "Gaiši pelēks augšējais robojums",
  "block.minecraft.banner.triangles_top.lime": "Gaiši zaļš augšējais robojums",
  "block.minecraft.banner.triangles_top.magenta": "Fuksīns augšējais robojums",
  "block.minecraft.banner.triangles_top.orange": "Oranžs augšējais robojums",
  "block.minecraft.banner.triangles_top.pink": "Rozā augšējais robojums",
  "block.minecraft.banner.triangles_top.purple": "Violets augšējais robojums",
  "block.minecraft.banner.triangles_top.red": "Sarkans augšējais robojums",
  "block.minecraft.banner.triangles_top.white": "Balts augšējais robojums",
  "block.minecraft.banner.triangles_top.yellow": "Dzeltens augšējais robojums",
  "block.minecraft.barrel": "Muca",
  "block.minecraft.barrier": "Barjera",
  "block.minecraft.basalt": "Bazalts",
  "block.minecraft.beacon": "Bāka",
  "block.minecraft.beacon.primary": "Primārais spēks",
  "block.minecraft.beacon.secondary": "Sekundārais spēks",
  "block.minecraft.bed.no_sleep": "Tu vari gulēt tikai nakts vai negaisa laikā",
  "block.minecraft.bed.not_safe": "Tu tagad nevari atpūsties, netālu ir briesmoņi",
  "block.minecraft.bed.obstructed": "Šī gulta ir aizsprostota",
  "block.minecraft.bed.occupied": "Šī gulta ir aizņemta",
  "block.minecraft.bed.too_far_away": "Tu nevari tagad gulēt, gulta atrodas pārāk tālu",
  "block.minecraft.bedrock": "Pamatiezis",
  "block.minecraft.bee_nest": "Bišu pūznis",
  "block.minecraft.beehive": "Bišu strops",
  "block.minecraft.beetroots": "Bietes",
  "block.minecraft.bell": "Zvans",
  "block.minecraft.big_dripleaf": "Liela krītlapa",
  "block.minecraft.big_dripleaf_stem": "Lielās krītlapas kāts",
  "block.minecraft.birch_button": "Bērza poga",
  "block.minecraft.birch_door": "Bērza durvis",
  "block.minecraft.birch_fence": "Bērza žogs",
  "block.minecraft.birch_fence_gate": "Bērza žoga vārti",
  "block.minecraft.birch_hanging_sign": "Iekarināta bērza zīme",
  "block.minecraft.birch_leaves": "Bērza lapas",
  "block.minecraft.birch_log": "Bērza baļķis",
  "block.minecraft.birch_planks": "Bērza dēļi",
  "block.minecraft.birch_pressure_plate": "Bērza spiediena plātne",
  "block.minecraft.birch_sapling": "Bērza stāds",
  "block.minecraft.birch_shelf": "Bērza plaukts",
  "block.minecraft.birch_sign": "Bērza zīme",
  "block.minecraft.birch_slab": "Bērza plāksne",
  "block.minecraft.birch_stairs": "Bērza kāpnes",
  "block.minecraft.birch_trapdoor": "Bērza lūka",
  "block.minecraft.birch_wall_hanging_sign": "Iekarināta bērza sienas zīme",
  "block.minecraft.birch_wall_sign": "Bērza sienas zīme",
  "block.minecraft.birch_wood": "Bērza koks",
  "block.minecraft.black_banner": "Melns karogs",
  "block.minecraft.black_bed": "Melna gulta",
  "block.minecraft.black_candle": "Melna svece",
  "block.minecraft.black_candle_cake": "Torte ar melnu sveci",
  "block.minecraft.black_carpet": "Melns paklājs",
  "block.minecraft.black_concrete": "Melns betons",
  "block.minecraft.black_concrete_powder": "Melns betona pulveris",
  "block.minecraft.black_glazed_terracotta": "Melna glazēta terakota",
  "block.minecraft.black_shulker_box": "Melna shulker kaste",
  "block.minecraft.black_stained_glass": "Melns krāsots stikls",
  "block.minecraft.black_stained_glass_pane": "Melna krāsota stikla plāksne",
  "block.minecraft.black_terracotta": "Melna terakota",
  "block.minecraft.black_wool": "Melna vilna",
  "block.minecraft.blackstone": "Melnakmens",
  "block.minecraft.blackstone_slab": "Melnakmens plāksne",
  "block.minecraft.blackstone_stairs": "Melnakmens Kāpnes",
  "block.minecraft.blackstone_wall": "Melnakmens mūris",
  "block.minecraft.blast_furnace": "Domnas Krāsns",
  "block.minecraft.blue_banner": "Zils karogs",
  "block.minecraft.blue_bed": "Zila gulta",
  "block.minecraft.blue_candle": "Zila svece",
  "block.minecraft.blue_candle_cake": "Torte ar zilu sveci",
  "block.minecraft.blue_carpet": "Zils paklājs",
  "block.minecraft.blue_concrete": "Zils betons",
  "block.minecraft.blue_concrete_powder": "Zils betona pulveris",
  "block.minecraft.blue_glazed_terracotta": "Zila glazēta terakota",
  "block.minecraft.blue_ice": "Zilais ledus",
  "block.minecraft.blue_orchid": "Zila orhideja",
  "block.minecraft.blue_shulker_box": "Zila shulker kaste",
  "block.minecraft.blue_stained_glass": "Zils krāsots stikls",
  "block.minecraft.blue_stained_glass_pane": "Zila krāsota stikla plāksne",
  "block.minecraft.blue_terracotta": "Zila terakota",
  "block.minecraft.blue_wool": "Zila vilna",
  "block.minecraft.bone_block": "Kaulu bloks",
  "block.minecraft.bookshelf": "Grāmatu plaukts",
  "block.minecraft.brain_coral": "Smadzeņu korallis",
  "block.minecraft.brain_coral_block": "Smadzeņu koraļļu bloks",
  "block.minecraft.brain_coral_fan": "Smadzeņu koraļļa spārns",
  "block.minecraft.brain_coral_wall_fan": "Smadzeņu koraļļa sienas vēdeklis",
  "block.minecraft.brewing_stand": "Brūvēšanas statīvs",
  "block.minecraft.brick_slab": "Ķieģeļu plāksne",
  "block.minecraft.brick_stairs": "Ķieģeļu kāpnes",
  "block.minecraft.brick_wall": "Ķieģeļu mūris",
  "block.minecraft.bricks": "Ķieģeļi",
  "block.minecraft.brown_banner": "Brūns karogs",
  "block.minecraft.brown_bed": "Brūna gulta",
  "block.minecraft.brown_candle": "Brūna svece",
  "block.minecraft.brown_candle_cake": "Torte ar brūnu sveci",
  "block.minecraft.brown_carpet": "Brūns paklājs",
  "block.minecraft.brown_concrete": "Brūns betons",
  "block.minecraft.brown_concrete_powder": "Brūns betona pulveris",
  "block.minecraft.brown_glazed_terracotta": "Brūna glazēta terakota",
  "block.minecraft.brown_mushroom": "Brūna sēne",
  "block.minecraft.brown_mushroom_block": "Brūno sēņu bloks",
  "block.minecraft.brown_shulker_box": "Brūna shulker kaste",
  "block.minecraft.brown_stained_glass": "Brūns krāsots stikls",
  "block.minecraft.brown_stained_glass_pane": "Brūna krāsota stikla plāksne",
  "block.minecraft.brown_terracotta": "Brūna terakota",
  "block.minecraft.brown_wool": "Brūna vilna",
  "block.minecraft.bubble_column": "Burbuļu kollona",
  "block.minecraft.bubble_coral": "Burbuļu korallis",
  "block.minecraft.bubble_coral_block": "Burbuļu koraļļu bloks",
  "block.minecraft.bubble_coral_fan": "Burbuļu koraļļa spārns",
  "block.minecraft.bubble_coral_wall_fan": "Burbuļu koraļļa sienas vēdeklis",
  "block.minecraft.budding_amethyst": "Augošs ametists",
  "block.minecraft.bush": "Krūms",
  "block.minecraft.cactus": "Kaktuss",
  "block.minecraft.cactus_flower": "Kaktusa zieds",
  "block.minecraft.cake": "Torte",
  "block.minecraft.calcite": "Kalcīts",
  "block.minecraft.calibrated_sculk_sensor": "Noregulēts skalu sensors",
  "block.minecraft.campfire": "Ugunskurs",
  "block.minecraft.candle": "Svece",
  "block.minecraft.candle_cake": "Torte ar sveci",
  "block.minecraft.carrots": "Burkāni",
  "block.minecraft.cartography_table": "Kartogrāfijas galds",
  "block.minecraft.carved_pumpkin": "Izgrebts ķirbis",
  "block.minecraft.cauldron": "Katls",
  "block.minecraft.cave_air": "Alu gaiss",
  "block.minecraft.cave_vines": "Alu vīnogulāji\n",
  "block.minecraft.cave_vines_plant": "Alu liānas augs",
  "block.minecraft.chain": "Ķēde",
  "block.minecraft.chain_command_block": "Ķēdes komandu bloks",
  "block.minecraft.cherry_button": "Ķirša poga",
  "block.minecraft.cherry_door": "Ķirša durvis",
  "block.minecraft.cherry_fence": "Ķirša žogs",
  "block.minecraft.cherry_fence_gate": "Ķirša žoga vārti",
  "block.minecraft.cherry_hanging_sign": "Iekarināta ķirša zīme",
  "block.minecraft.cherry_leaves": "Ķirša lapas",
  "block.minecraft.cherry_log": "Ķirša baļķis",
  "block.minecraft.cherry_planks": "Ķirša dēļi",
  "block.minecraft.cherry_pressure_plate": "Ķirša spiediena plātne",
  "block.minecraft.cherry_sapling": "Ķirša stāds",
  "block.minecraft.cherry_shelf": "Ķirša plaukts",
  "block.minecraft.cherry_sign": "Ķirša zīme",
  "block.minecraft.cherry_slab": "Ķirša plāksne",
  "block.minecraft.cherry_stairs": "Ķirša kāpnes",
  "block.minecraft.cherry_trapdoor": "Ķirša lūka",
  "block.minecraft.cherry_wall_hanging_sign": "Iekarināta ķirša sienas zīme",
  "block.minecraft.cherry_wall_sign": "Ķirša sienas zīme",
  "block.minecraft.cherry_wood": "Ķirša koks",
  "block.minecraft.chest": "Lāde",
  "block.minecraft.chipped_anvil": "Apdauzīta lakta",
  "block.minecraft.chiseled_bookshelf": "Slīpēts grāmatu plaukts",
  "block.minecraft.chiseled_copper": "Slīpēts varš",
  "block.minecraft.chiseled_deepslate": "Slīpēts dziļslāneklis",
  "block.minecraft.chiseled_nether_bricks": "Slīpēti Nether ķieģeļi",
  "block.minecraft.chiseled_polished_blackstone": "Nolīpēts pulēts melnakmens",
  "block.minecraft.chiseled_quartz_block": "Slīpēts kvarca bloks",
  "block.minecraft.chiseled_red_sandstone": "Slīpēts sarkanais smilšakmens",
  "block.minecraft.chiseled_resin_bricks": "Slīpēti Tufa Ķieģeļi",
  "block.minecraft.chiseled_sandstone": "Noslīpēts smilšakmens",
  "block.minecraft.chiseled_stone_bricks": "Noslīpēti akmens ķieģeļi",
  "block.minecraft.chiseled_tuff": "Slīpēts Tufs",
  "block.minecraft.chiseled_tuff_bricks": "Slīpēti Tufa ķieģeļi",
  "block.minecraft.chorus_flower": "Kora zieds",
  "block.minecraft.chorus_plant": "Kora augs",
  "block.minecraft.clay": "Māls",
  "block.minecraft.closed_eyeblossom": "Aizvērts aczieds",
  "block.minecraft.coal_block": "Ogļu bloks",
  "block.minecraft.coal_ore": "Akmeņogles",
  "block.minecraft.coarse_dirt": "Rupja zeme",
  "block.minecraft.cobbled_deepslate": "Saplaisājis dziļslāneklis",
  "block.minecraft.cobbled_deepslate_slab": "Saplaisājusi dziļslānekļa plāksne",
  "block.minecraft.cobbled_deepslate_stairs": "Saplaisājuša dziļslānekļa pakāpieni",
  "block.minecraft.cobbled_deepslate_wall": "Saplaisājuša dziļslānekļa mūris",
  "block.minecraft.cobblestone": "Bruģakmens",
  "block.minecraft.cobblestone_slab": "Bruģakmens plāksne",
  "block.minecraft.cobblestone_stairs": "Bruģakmens kāpnes",
  "block.minecraft.cobblestone_wall": "Bruģakmens mūris",
  "block.minecraft.cobweb": "Zirnekļtīkls",
  "block.minecraft.cocoa": "Kakao",
  "block.minecraft.command_block": "Komandu bloks",
  "block.minecraft.comparator": "Redstone salīdzinātājs",
  "block.minecraft.composter": "Kompostētājs",
  "block.minecraft.conduit": "Konduits",
  "block.minecraft.copper_bars": "Vara restes",
  "block.minecraft.copper_block": "Vara bloks",
  "block.minecraft.copper_bulb": "Vara spuldze",
  "block.minecraft.copper_chain": "Vara ķēde",
  "block.minecraft.copper_chest": "Vara lāde",
  "block.minecraft.copper_door": "Vara durvis",
  "block.minecraft.copper_golem_statue": "Vara golema statuja",
  "block.minecraft.copper_grate": "Vara režģis",
  "block.minecraft.copper_lantern": "Vara laterna",
  "block.minecraft.copper_ore": "Vara rūda",
  "block.minecraft.copper_torch": "Vara lāpa",
  "block.minecraft.copper_trapdoor": "Vara lamašu durvis",
  "block.minecraft.copper_wall_torch": "Vara sienas lāpa",
  "block.minecraft.cornflower": "Rudzupuķe",
  "block.minecraft.cracked_deepslate_bricks": "Saplaisājuši dziļslānekļa ķieģeļi",
  "block.minecraft.cracked_deepslate_tiles": "Saplaisājušas dziļslānekļa flīzes",
  "block.minecraft.cracked_nether_bricks": "Ieplaisājuši Nether ķieģeļi",
  "block.minecraft.cracked_polished_blackstone_bricks": "Ieplaisājuši Pulēti Melnakmens Ķieģeļi",
  "block.minecraft.cracked_stone_bricks": "Saplaisājuši akmens ķieģeļi",
  "block.minecraft.crafter": "Amatnieks",
  "block.minecraft.crafting_table": "Darbagalds",
  "block.minecraft.creaking_heart": "Čīktoņa sirds",
  "block.minecraft.creeper_head": "Creeper galva",
  "block.minecraft.creeper_wall_head": "Creeper galva uz sienas",
  "block.minecraft.crimson_button": "Tumšsarkana poga",
  "block.minecraft.crimson_door": "Tumšsarkanas durvis",
  "block.minecraft.crimson_fence": "Tumšsarkans žogs",
  "block.minecraft.crimson_fence_gate": "Tumšsarkana žoga vārti",
  "block.minecraft.crimson_fungus": "Tumšsarkana sēnīte",
  "block.minecraft.crimson_hanging_sign": "Iekarināta tumšsarkana zīme",
  "block.minecraft.crimson_hyphae": "Tumšsarkanas hifas",
  "block.minecraft.crimson_nylium": "Tumšsarkans nīlijs",
  "block.minecraft.crimson_planks": "Tumšsarkani dēļi",
  "block.minecraft.crimson_pressure_plate": "Tumšsarkana spiediena plāksne",
  "block.minecraft.crimson_roots": "Tumšsarkanas saknes",
  "block.minecraft.crimson_shelf": "Vara plaukts",
  "block.minecraft.crimson_sign": "Tumšsarkana zīme",
  "block.minecraft.crimson_slab": "Tumšsarkana plāksne",
  "block.minecraft.crimson_stairs": "Tumšsarkanas kāpnes",
  "block.minecraft.crimson_stem": "Tumšsarkans kāts",
  "block.minecraft.crimson_trapdoor": "Tumšsarkana lūka",
  "block.minecraft.crimson_wall_hanging_sign": "Iekarināta tumšsarkana sienas zīme",
  "block.minecraft.crimson_wall_sign": "Tumšsarkana sienas zīme",
  "block.minecraft.crying_obsidian": "Raudošais Obsidiāns",
  "block.minecraft.cut_copper": "Šķelts varš",
  "block.minecraft.cut_copper_slab": "Šķelta vara plāksne",
  "block.minecraft.cut_copper_stairs": "Šķelta vara pakāpieni",
  "block.minecraft.cut_red_sandstone": "Griezts sarkanais smilšakmens",
  "block.minecraft.cut_red_sandstone_slab": "Griezta sarkanā smilšakmens plāksne",
  "block.minecraft.cut_sandstone": "Griezts smilšakmens",
  "block.minecraft.cut_sandstone_slab": "Griezta smilšakmens plāksne",
  "block.minecraft.cyan_banner": "Ciāns karogs",
  "block.minecraft.cyan_bed": "Ciāna gulta",
  "block.minecraft.cyan_candle": "Ciāna svece",
  "block.minecraft.cyan_candle_cake": "Torte ar ciānu sveci",
  "block.minecraft.cyan_carpet": "Ciāns paklājs",
  "block.minecraft.cyan_concrete": "Ciāns betons",
  "block.minecraft.cyan_concrete_powder": "Ciāns betona pulveris",
  "block.minecraft.cyan_glazed_terracotta": "Ciāna glazēta terakota",
  "block.minecraft.cyan_shulker_box": "Ciāna shulker kaste",
  "block.minecraft.cyan_stained_glass": "Ciāns krāsots stikls",
  "block.minecraft.cyan_stained_glass_pane": "Ciāna krāsota stikla plāksne",
  "block.minecraft.cyan_terracotta": "Ciāna terakota",
  "block.minecraft.cyan_wool": "Ciāna vilna",
  "block.minecraft.damaged_anvil": "Bojāta lakta",
  "block.minecraft.dandelion": "Pienene",
  "block.minecraft.dark_oak_button": "Tumšā ozola poga",
  "block.minecraft.dark_oak_door": "Tumšā ozola durvis",
  "block.minecraft.dark_oak_fence": "Tumšā ozola žogs",
  "block.minecraft.dark_oak_fence_gate": "Tumšā ozola žoga vārti",
  "block.minecraft.dark_oak_hanging_sign": "Iekarināta tumšā ozola zīme",
  "block.minecraft.dark_oak_leaves": "Tumšā ozola lapas",
  "block.minecraft.dark_oak_log": "Tumšā ozola baļķis",
  "block.minecraft.dark_oak_planks": "Tumšā ozola dēļi",
  "block.minecraft.dark_oak_pressure_plate": "Tumšā ozola spiediena plātne",
  "block.minecraft.dark_oak_sapling": "Tumšā ozola stāds",
  "block.minecraft.dark_oak_shelf": "Tumšā ozola plaukts",
  "block.minecraft.dark_oak_sign": "Tumšā ozola zīme",
  "block.minecraft.dark_oak_slab": "Tumšā ozola plāksne",
  "block.minecraft.dark_oak_stairs": "Tumšā ozola kāpnes",
  "block.minecraft.dark_oak_trapdoor": "Tumšā ozola lūka",
  "block.minecraft.dark_oak_wall_hanging_sign": "Iekarināta tumšā ozola sienas zīme",
  "block.minecraft.dark_oak_wall_sign": "Tumšā ozola sienas zīme",
  "block.minecraft.dark_oak_wood": "Tumšais ozols",
  "block.minecraft.dark_prismarine": "Tumšais prizmarīns",
  "block.minecraft.dark_prismarine_slab": "Tumšā prizmarīna plāksne",
  "block.minecraft.dark_prismarine_stairs": "Tumšā prizmarīna kāpnes",
  "block.minecraft.daylight_detector": "Dienasgaismas detektors",
  "block.minecraft.dead_brain_coral": "Beigts smadzeņu korallis",
  "block.minecraft.dead_brain_coral_block": "Beigts smadzeņu koraļļu bloks",
  "block.minecraft.dead_brain_coral_fan": "Beigts smadzeņu koraļļa vēdeklis",
  "block.minecraft.dead_brain_coral_wall_fan": "Beigts smadzeņu koraļļa sienas vēdeklis",
  "block.minecraft.dead_bubble_coral": "Beigts burbuļu korallis",
  "block.minecraft.dead_bubble_coral_block": "Beigts burbuļu koraļļu bloks",
  "block.minecraft.dead_bubble_coral_fan": "Beigts burbuļu koraļļa vēdeklis",
  "block.minecraft.dead_bubble_coral_wall_fan": "Beigts burbuļu koraļļa sienas vēdeklis",
  "block.minecraft.dead_bush": "Nokaltis krūms",
  "block.minecraft.dead_fire_coral": "Beigts uguns korallis",
  "block.minecraft.dead_fire_coral_block": "Beigts uguns koraļļu bloks",
  "block.minecraft.dead_fire_coral_fan": "Beigts uguns koraļļa vēdeklis",
  "block.minecraft.dead_fire_coral_wall_fan": "Beigts uguns koraļļa sienas vēdeklis",
  "block.minecraft.dead_horn_coral": "Beigts raga korallis",
  "block.minecraft.dead_horn_coral_block": "Beigts raga koraļļu bloks",
  "block.minecraft.dead_horn_coral_fan": "Beigts raga koraļļa vēdeklis",
  "block.minecraft.dead_horn_coral_wall_fan": "Beigts raga koraļļa sienas vēdeklis",
  "block.minecraft.dead_tube_coral": "Miris caurules korallis",
  "block.minecraft.dead_tube_coral_block": "Beigts caurules koraļļu bloks",
  "block.minecraft.dead_tube_coral_fan": "Beigts caurules koraļļa vēdeklis",
  "block.minecraft.dead_tube_coral_wall_fan": "Beigts caurules koraļļa sienas vēdeklis",
  "block.minecraft.decorated_pot": "Izdekorēts pods",
  "block.minecraft.deepslate": "Dziļslāneklis",
  "block.minecraft.deepslate_brick_slab": "Dziļslānekļa ķieģeļu plāksne",
  "block.minecraft.deepslate_brick_stairs": "Dziļslānekļa ķieģeļu kāpnes",
  "block.minecraft.deepslate_brick_wall": "Dziļslānekļa ķieģeļu mūris",
  "block.minecraft.deepslate_bricks": "Dziļslānekļa ķieģeļi",
  "block.minecraft.deepslate_coal_ore": "Dziļslānekļa ogļu rūda",
  "block.minecraft.deepslate_copper_ore": "Dziļslānekļa vara rūda",
  "block.minecraft.deepslate_diamond_ore": "Dziļslānekļa dimanta rūda",
  "block.minecraft.deepslate_emerald_ore": "Dziļslānekļa smaragda rūda",
  "block.minecraft.deepslate_gold_ore": "Dziļslānekļa zelta rūda",
  "block.minecraft.deepslate_iron_ore": "Dziļslānekļa dzelzs rūda",
  "block.minecraft.deepslate_lapis_ore": "Dziļslānekļa lazurīta rūda",
  "block.minecraft.deepslate_redstone_ore": "Dziļslānekļa Redstone rūda",
  "block.minecraft.deepslate_tile_slab": "Dziļslānekļa flīžu plāksne",
  "block.minecraft.deepslate_tile_stairs": "Dziļslānekļa flīžu kāpnes",
  "block.minecraft.deepslate_tile_wall": "Dziļslānekļa flīžu mūris",
  "block.minecraft.deepslate_tiles": "Dziļslānekļa flīzes",
  "block.minecraft.detector_rail": "Detektorsliedes",
  "block.minecraft.diamond_block": "Dimantu bloks",
  "block.minecraft.diamond_ore": "Dimanta rūda",
  "block.minecraft.diorite": "Diorīts",
  "block.minecraft.diorite_slab": "Diorīta plāksne",
  "block.minecraft.diorite_stairs": "Diorīta kāpnes",
  "block.minecraft.diorite_wall": "Diorīta mūris",
  "block.minecraft.dirt": "Zeme",
  "block.minecraft.dirt_path": "Zemes ceļš",
  "block.minecraft.dispenser": "Izšāvējs",
  "block.minecraft.dragon_egg": "Pūķa ola",
  "block.minecraft.dragon_head": "Pūķa galva",
  "block.minecraft.dragon_wall_head": "Pūķa galva uz sienas",
  "block.minecraft.dried_ghast": "Izžuvis Ghast",
  "block.minecraft.dried_kelp_block": "Izkaltētu brūnaļģu bloks",
  "block.minecraft.dripstone_block": "Tekakmens bloks",
  "block.minecraft.dropper": "Izsviedējs",
  "block.minecraft.emerald_block": "Smaragda bloks",
  "block.minecraft.emerald_ore": "Smaragda rūda",
  "block.minecraft.enchanting_table": "Burvestību galds",
  "block.minecraft.end_gateway": "End vārteja",
  "block.minecraft.end_portal": "End portāls",
  "block.minecraft.end_portal_frame": "End portāla rāmis",
  "block.minecraft.end_rod": "End stienis",
  "block.minecraft.end_stone": "End Akmens",
  "block.minecraft.end_stone_brick_slab": "End akmens ķieģeļu plāksne",
  "block.minecraft.end_stone_brick_stairs": "End akmens ķieģeļu kāpnes",
  "block.minecraft.end_stone_brick_wall": "End akmens ķieģeļu mūris",
  "block.minecraft.end_stone_bricks": "End akmens ķieģeļi",
  "block.minecraft.ender_chest": "Ender lāde",
  "block.minecraft.exposed_chiseled_copper": "Atklāts slīpēts varš",
  "block.minecraft.exposed_copper": "Atsegts varš",
  "block.minecraft.exposed_copper_bars": "Atsegtas vara restes",
  "block.minecraft.exposed_copper_bulb": "Atklāta vara spuldze",
  "block.minecraft.exposed_copper_chain": "Atsegta vara ķēde",
  "block.minecraft.exposed_copper_chest": "Atsegta vara lāde",
  "block.minecraft.exposed_copper_door": "Atsegtas vara durvis",
  "block.minecraft.exposed_copper_golem_statue": "Atsegta vara golema statuja",
  "block.minecraft.exposed_copper_grate": "Atklāts vara režģis",
  "block.minecraft.exposed_copper_lantern": "Atklāta vara laterna",
  "block.minecraft.exposed_copper_trapdoor": "Atsegtas vara trapa durvis",
  "block.minecraft.exposed_cut_copper": "Atsegts šķelts varš",
  "block.minecraft.exposed_cut_copper_slab": "Atsegta šķelta vara plāksne",
  "block.minecraft.exposed_cut_copper_stairs": "Atsegti šķelti vara pakāpieni",
  "block.minecraft.exposed_lightning_rod": "Atsegts zibensnovedējs",
  "block.minecraft.farmland": "Aramzeme",
  "block.minecraft.fern": "Paparde",
  "block.minecraft.fire": "Uguns",
  "block.minecraft.fire_coral": "Uguns korallis",
  "block.minecraft.fire_coral_block": "Uguns koraļļu bloks",
  "block.minecraft.fire_coral_fan": "Uguns koraļļa spārns",
  "block.minecraft.fire_coral_wall_fan": "Uguns koraļļa sienas vēdeklis",
  "block.minecraft.firefly_bush": "Spīdvaboļu Krūms",
  "block.minecraft.fletching_table": "Bultu kalšanas galds",
  "block.minecraft.flower_pot": "Puķupods",
  "block.minecraft.flowering_azalea": "Ziedoša acālija",
  "block.minecraft.flowering_azalea_leaves": "Ziedošas acālijas lapas",
  "block.minecraft.frogspawn": "Ikri",
  "block.minecraft.frosted_ice": "Uzsalis ledus",
  "block.minecraft.furnace": "Krāsns",
  "block.minecraft.gilded_blackstone": "Apzeltīts Melnakmens",
  "block.minecraft.glass": "Stikls",
  "block.minecraft.glass_pane": "Stikla plāksne",
  "block.minecraft.glow_lichen": "Spīdošie ķērpji",
  "block.minecraft.glowstone": "Mirdzakmens",
  "block.minecraft.gold_block": "Zelta bloks",
  "block.minecraft.gold_ore": "Zelta rūda",
  "block.minecraft.golden_dandelion": "Zelta Pienene",
  "block.minecraft.granite": "Granīts",
  "block.minecraft.granite_slab": "Granīta plāksne",
  "block.minecraft.granite_stairs": "Granīta kāpnes",
  "block.minecraft.granite_wall": "Granīta mūris",
  "block.minecraft.grass": "Zāle",
  "block.minecraft.grass_block": "Zāles bloks",
  "block.minecraft.gravel": "Grants",
  "block.minecraft.gray_banner": "Pelēks karogs",
  "block.minecraft.gray_bed": "Pelēka gulta",
  "block.minecraft.gray_candle": "Pelēka svece",
  "block.minecraft.gray_candle_cake": "Torte ar pelēku sveci",
  "block.minecraft.gray_carpet": "Pelēks paklājs",
  "block.minecraft.gray_concrete": "Pelēks betons",
  "block.minecraft.gray_concrete_powder": "Pelēks betona pulveris",
  "block.minecraft.gray_glazed_terracotta": "Pelēka glazēta terakota",
  "block.minecraft.gray_shulker_box": "Pelēka šulkera kaste",
  "block.minecraft.gray_stained_glass": "Pelēks krāsots stikls",
  "block.minecraft.gray_stained_glass_pane": "Pelēka krāsota stikla plāksne",
  "block.minecraft.gray_terracotta": "Pelēka terakota",
  "block.minecraft.gray_wool": "Pelēka vilna",
  "block.minecraft.green_banner": "Zaļš karogs",
  "block.minecraft.green_bed": "Zaļa gulta",
  "block.minecraft.green_candle": "Zaļa svece",
  "block.minecraft.green_candle_cake": "Torte ar zaļu sveci",
  "block.minecraft.green_carpet": "Zaļš paklājs",
  "block.minecraft.green_concrete": "Zaļš betons",
  "block.minecraft.green_concrete_powder": "Zaļš betona pulveris",
  "block.minecraft.green_glazed_terracotta": "Zaļa glazēta terakota",
  "block.minecraft.green_shulker_box": "Zaļa shulker kaste",
  "block.minecraft.green_stained_glass": "Zaļš krāsots stikls",
  "block.minecraft.green_stained_glass_pane": "Zaļa krāsota stikla plāksne",
  "block.minecraft.green_terracotta": "Zaļa terakota",
  "block.minecraft.green_wool": "Zaļa vilna",
  "block.minecraft.grindstone": "Galoda",
  "block.minecraft.hanging_roots": "Karājošas saknes",
  "block.minecraft.hay_block": "Siena ķīpa",
  "block.minecraft.heavy_core": "Smagais kodols",
  "block.minecraft.heavy_weighted_pressure_plate": "Smaga spiediena plātne",
  "block.minecraft.honey_block": "Medus bloks",
  "block.minecraft.honeycomb_block": "Medus šūnu bloks",
  "block.minecraft.hopper": "Piltuve",
  "block.minecraft.horn_coral": "Raga korallis",
  "block.minecraft.horn_coral_block": "Raga koraļļu bloks",
  "block.minecraft.horn_coral_fan": "Raga koraļļa spārns",
  "block.minecraft.horn_coral_wall_fan": "Raga Koraļļa Sienas Vēdeklis",
  "block.minecraft.ice": "Ledus",
  "block.minecraft.infested_chiseled_stone_bricks": "Inficēti noslīpēti akmens ķieģeļi",
  "block.minecraft.infested_cobblestone": "Inficēts bruģakmens",
  "block.minecraft.infested_cracked_stone_bricks": "Inficēti saplaisājuši akmens ķieģeļi",
  "block.minecraft.infested_deepslate": "Inficēts dziļslāneklis",
  "block.minecraft.infested_mossy_stone_bricks": "Inficēti apsūnojuši akmens ķieģeļi",
  "block.minecraft.infested_stone": "Inficēts akmens",
  "block.minecraft.infested_stone_bricks": "Inficēti akmens ķieģeļi",
  "block.minecraft.iron_bars": "Dzelzs restes",
  "block.minecraft.iron_block": "Dzelzs bloks",
  "block.minecraft.iron_chain": "Dzelzs ķēde",
  "block.minecraft.iron_door": "Dzelzs druvis",
  "block.minecraft.iron_ore": "Dzelzs rūda",
  "block.minecraft.iron_trapdoor": "Dzelzs lūka",
  "block.minecraft.jack_o_lantern": "Ķirbja laterna",
  "block.minecraft.jigsaw": "Puzles bloks",
  "block.minecraft.jukebox": "Plašu atskaņotājs",
  "block.minecraft.jungle_button": "Džungļu koka poga",
  "block.minecraft.jungle_door": "Džungļu durvis",
  "block.minecraft.jungle_fence": "Džungļu koka žogs",
  "block.minecraft.jungle_fence_gate": "Džungļu žoga vārti",
  "block.minecraft.jungle_hanging_sign": "Iekarināta džungļu koka zīme",
  "block.minecraft.jungle_leaves": "Džungļu koka lapas",
  "block.minecraft.jungle_log": "Džungļu koka baļķis",
  "block.minecraft.jungle_planks": "Džungļu koka dēļi",
  "block.minecraft.jungle_pressure_plate": "Džungļu koka spiediena plātne",
  "block.minecraft.jungle_sapling": "Džungļu koka stāds",
  "block.minecraft.jungle_shelf": "Džungļu koka plaukts",
  "block.minecraft.jungle_sign": "Džungļu koka zīme",
  "block.minecraft.jungle_slab": "Džungļu koka plāksne",
  "block.minecraft.jungle_stairs": "Džungļu koka kāpnes",
  "block.minecraft.jungle_trapdoor": "Džungļu lūka",
  "block.minecraft.jungle_wall_hanging_sign": "Iekarināta džungļu koka sienas zīme",
  "block.minecraft.jungle_wall_sign": "Džungļu koka sienas zīme",
  "block.minecraft.jungle_wood": "Džungļu koks",
  "block.minecraft.kelp": "Brūnaļģe",
  "block.minecraft.kelp_plant": "Brūnaļģes augs",
  "block.minecraft.ladder": "Kāpnes",
  "block.minecraft.lantern": "Laterna",
  "block.minecraft.lapis_block": "Lazurīta bloks",
  "block.minecraft.lapis_ore": "Lazurīta rūda",
  "block.minecraft.large_amethyst_bud": "Liels ametista kristāls",
  "block.minecraft.large_fern": "Liela paparde",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Lavas katls",
  "block.minecraft.leaf_litter": "Kritušas lapas",
  "block.minecraft.lectern": "Lektora galds",
  "block.minecraft.lever": "Svira",
  "block.minecraft.light": "Gaisma",
  "block.minecraft.light_blue_banner": "Gaiši zils karogs",
  "block.minecraft.light_blue_bed": "Gaiši zila gulta",
  "block.minecraft.light_blue_candle": "Gaiši zila svece",
  "block.minecraft.light_blue_candle_cake": "Torte ar gaiši zilu sveci",
  "block.minecraft.light_blue_carpet": "Gaiši zils paklājs",
  "block.minecraft.light_blue_concrete": "Gaiši zils betons",
  "block.minecraft.light_blue_concrete_powder": "Gaiši zils betona pulveris",
  "block.minecraft.light_blue_glazed_terracotta": "Gaiši zila glazēta terakota",
  "block.minecraft.light_blue_shulker_box": "Gaiši zila shulker kaste",
  "block.minecraft.light_blue_stained_glass": "Gaiši zils krāsots stikls",
  "block.minecraft.light_blue_stained_glass_pane": "Gaiši zila krāsota stikla plāksne",
  "block.minecraft.light_blue_terracotta": "Gaiši zila terakota",
  "block.minecraft.light_blue_wool": "Gaiši zila vilna",
  "block.minecraft.light_gray_banner": "Gaiši pelēks karogs",
  "block.minecraft.light_gray_bed": "Gaiši pelēka gulta",
  "block.minecraft.light_gray_candle": "Gaiši pelēka svece",
  "block.minecraft.light_gray_candle_cake": "Torte ar gaiši pelēku sveci",
  "block.minecraft.light_gray_carpet": "Gaiši pelēks paklājs",
  "block.minecraft.light_gray_concrete": "Gaiši pelēks betons",
  "block.minecraft.light_gray_concrete_powder": "Gaiši pelēks betona pulveris",
  "block.minecraft.light_gray_glazed_terracotta": "Gaiši pelēka glazēta terakota",
  "block.minecraft.light_gray_shulker_box": "Gaiši pelēka shulker kaste",
  "block.minecraft.light_gray_stained_glass": "Gaiši pelēks krāsots stikls",
  "block.minecraft.light_gray_stained_glass_pane": "Gaiši pelēka krāsota stikla plāksne",
  "block.minecraft.light_gray_terracotta": "Gaiši pelēka terakota",
  "block.minecraft.light_gray_wool": "Gaiši pelēka vilna",
  "block.minecraft.light_weighted_pressure_plate": "Viegla spiediena plātne",
  "block.minecraft.lightning_rod": "Zibensnovedējs",
  "block.minecraft.lilac": "Ceriņi",
  "block.minecraft.lily_of_the_valley": "Maijpuķīte",
  "block.minecraft.lily_pad": "Ūdensrozes",
  "block.minecraft.lime_banner": "Gaiši zaļš karogs",
  "block.minecraft.lime_bed": "Gaiši zaļa gulta",
  "block.minecraft.lime_candle": "Gaiši zaļa svece",
  "block.minecraft.lime_candle_cake": "Torte ar gaiši zaļu sveci",
  "block.minecraft.lime_carpet": "Gaiši zaļš paklājs",
  "block.minecraft.lime_concrete": "Gaiši zaļš betons",
  "block.minecraft.lime_concrete_powder": "Gaiši zaļš betona pulveris",
  "block.minecraft.lime_glazed_terracotta": "Gaiši zaļa glazēta terakota",
  "block.minecraft.lime_shulker_box": "Gaiši zaļa shulker kaste",
  "block.minecraft.lime_stained_glass": "Gaiši zaļš krāsots stikls",
  "block.minecraft.lime_stained_glass_pane": "Gaiši zaļa krāsota stikla plāksne",
  "block.minecraft.lime_terracotta": "Gaiši zaļa terakota",
  "block.minecraft.lime_wool": "Gaiši zaļa vilna",
  "block.minecraft.lodestone": "Dzīslakmens",
  "block.minecraft.loom": "Stelles",
  "block.minecraft.magenta_banner": "Fuksīns karogs",
  "block.minecraft.magenta_bed": "Fuksīna gulta",
  "block.minecraft.magenta_candle": "Fuksīna svece",
  "block.minecraft.magenta_candle_cake": "Torte ar fuksīnu sveci",
  "block.minecraft.magenta_carpet": "Fuksīns paklājs",
  "block.minecraft.magenta_concrete": "Fuksīns betons",
  "block.minecraft.magenta_concrete_powder": "Fuksīns betona pulveris",
  "block.minecraft.magenta_glazed_terracotta": "Fuksīna glazēta terakota",
  "block.minecraft.magenta_shulker_box": "Fuksīna shulker kaste",
  "block.minecraft.magenta_stained_glass": "Fuksīns krāsots stikls",
  "block.minecraft.magenta_stained_glass_pane": "Fuksīna krāsota stikla plāksne",
  "block.minecraft.magenta_terracotta": "Fuksīna terakota",
  "block.minecraft.magenta_wool": "Fuksīna vilna",
  "block.minecraft.magma_block": "Magmas bloks",
  "block.minecraft.mangrove_button": "Mangroves poga",
  "block.minecraft.mangrove_door": "Mangroves durvis",
  "block.minecraft.mangrove_fence": "Mangroves žogs",
  "block.minecraft.mangrove_fence_gate": "Mangroves žoga vārti",
  "block.minecraft.mangrove_hanging_sign": "Iekarināta mangroves zīme",
  "block.minecraft.mangrove_leaves": "Mangroves lapas",
  "block.minecraft.mangrove_log": "Mangroves baļķis",
  "block.minecraft.mangrove_planks": "Mangroves dēļi",
  "block.minecraft.mangrove_pressure_plate": "Mangroves spiediena plāksne",
  "block.minecraft.mangrove_propagule": "Mangroves pumpurs",
  "block.minecraft.mangrove_roots": "Mangroves saknes",
  "block.minecraft.mangrove_shelf": "Mangroves plaukts",
  "block.minecraft.mangrove_sign": "Mangroves zīme",
  "block.minecraft.mangrove_slab": "Mangroves plāksne",
  "block.minecraft.mangrove_stairs": "Mangroves kāpnes",
  "block.minecraft.mangrove_trapdoor": "Mangroves lūka",
  "block.minecraft.mangrove_wall_hanging_sign": "Iekarināta mangroves sienas zīme",
  "block.minecraft.mangrove_wall_sign": "Mangroves sienas zīmes",
  "block.minecraft.mangrove_wood": "Mangroves koks",
  "block.minecraft.medium_amethyst_bud": "Vidējs ametista kristāls",
  "block.minecraft.melon": "Arbūzs",
  "block.minecraft.melon_stem": "Arbūza stumbrs",
  "block.minecraft.moss_block": "Sūnu bloks",
  "block.minecraft.moss_carpet": "Sūnu paklājs",
  "block.minecraft.mossy_cobblestone": "Apsūnojis bruģakmens",
  "block.minecraft.mossy_cobblestone_slab": "Apsūnojusi bruģakmens plāksne",
  "block.minecraft.mossy_cobblestone_stairs": "Apsūnojušas bruģakmens kāpnes",
  "block.minecraft.mossy_cobblestone_wall": "Apsūnojis bruģakmens mūris",
  "block.minecraft.mossy_stone_brick_slab": "Apsūnojusi akmens ķieģeļu plāksne",
  "block.minecraft.mossy_stone_brick_stairs": "Apsūnojušas akmens ķieģeļu kāpnes",
  "block.minecraft.mossy_stone_brick_wall": "Apsūnojušu akmens ķieģeļu mūris",
  "block.minecraft.mossy_stone_bricks": "Apsūnojuši akmens ķieģeļi",
  "block.minecraft.moving_piston": "Virzulis kustībā",
  "block.minecraft.mud": "Dubļi",
  "block.minecraft.mud_brick_slab": "Dubļu ķieģeļu plāksne",
  "block.minecraft.mud_brick_stairs": "Dubļu ķieģeļu kāpnes",
  "block.minecraft.mud_brick_wall": "Dubļu ķieģeļu mūris",
  "block.minecraft.mud_bricks": "Dubļu ķieģeļi",
  "block.minecraft.muddy_mangrove_roots": "Dubļainas mangroves saknes",
  "block.minecraft.mushroom_stem": "Sēnes kāts",
  "block.minecraft.mycelium": "Micēlijs",
  "block.minecraft.nether_brick_fence": "Nether ķieģeļu mūris",
  "block.minecraft.nether_brick_slab": "Nether ķieģeļu plāksne",
  "block.minecraft.nether_brick_stairs": "Nether ķieģeļu kāpnes",
  "block.minecraft.nether_brick_wall": "Nether ķieģeļu mūris",
  "block.minecraft.nether_bricks": "Nether ķieģeļi",
  "block.minecraft.nether_gold_ore": "Nether zelta rūda",
  "block.minecraft.nether_portal": "Nether portāls",
  "block.minecraft.nether_quartz_ore": "Nether kvarca rūda",
  "block.minecraft.nether_sprouts": "Nether asni",
  "block.minecraft.nether_wart": "Nether kārpa",
  "block.minecraft.nether_wart_block": "Nether kārpu bloks",
  "block.minecraft.netherite_block": "Nezerīta bloks",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Nošu bloks",
  "block.minecraft.oak_button": "Ozola poga",
  "block.minecraft.oak_door": "Ozola durvis",
  "block.minecraft.oak_fence": "Ozola žogs",
  "block.minecraft.oak_fence_gate": "Ozolkoka žoga vārti",
  "block.minecraft.oak_hanging_sign": "Iekarināta ozola zīme",
  "block.minecraft.oak_leaves": "Ozola lapas",
  "block.minecraft.oak_log": "Ozola baļķis",
  "block.minecraft.oak_planks": "Ozola dēļi",
  "block.minecraft.oak_pressure_plate": "Ozola spiediena plātne",
  "block.minecraft.oak_sapling": "Ozola stāds",
  "block.minecraft.oak_shelf": "Ozola plaukts",
  "block.minecraft.oak_sign": "Ozola zīme",
  "block.minecraft.oak_slab": "Ozola plāksne",
  "block.minecraft.oak_stairs": "Ozola kāpnes",
  "block.minecraft.oak_trapdoor": "Ozola lūka",
  "block.minecraft.oak_wall_hanging_sign": "Iekarināta ozola sienas zīme",
  "block.minecraft.oak_wall_sign": "Ozola sienas zīme",
  "block.minecraft.oak_wood": "Ozols",
  "block.minecraft.observer": "Novērotājs",
  "block.minecraft.obsidian": "Obsidiāns",
  "block.minecraft.ochre_froglight": "Okera varžu lampa",
  "block.minecraft.ominous_banner": "Draudīgs karogs",
  "block.minecraft.open_eyeblossom": "Uzplaucis aczieds",
  "block.minecraft.orange_banner": "Oranžs karogs",
  "block.minecraft.orange_bed": "Oranža gulta",
  "block.minecraft.orange_candle": "Oranža svece",
  "block.minecraft.orange_candle_cake": "Torte ar oranžu sveci",
  "block.minecraft.orange_carpet": "Oranžs paklājs",
  "block.minecraft.orange_concrete": "Oranžš betons",
  "block.minecraft.orange_concrete_powder": "Oranžs betona pulveris",
  "block.minecraft.orange_glazed_terracotta": "Oranža glazēta terakota",
  "block.minecraft.orange_shulker_box": "Oranža shulker kaste",
  "block.minecraft.orange_stained_glass": "Oranžs krāsots stikls",
  "block.minecraft.orange_stained_glass_pane": "Oranža krāsota stikla plāksne",
  "block.minecraft.orange_terracotta": "Oranža terakota",
  "block.minecraft.orange_tulip": "Oranža tulpe",
  "block.minecraft.orange_wool": "Oranža vilna",
  "block.minecraft.oxeye_daisy": "Margrietiņa",
  "block.minecraft.oxidized_chiseled_copper": "Oksidēts slīpēts varš",
  "block.minecraft.oxidized_copper": "Oksidēts varš",
  "block.minecraft.oxidized_copper_bars": "Oksidētas vara restes",
  "block.minecraft.oxidized_copper_bulb": "Oksidēta vara spuldze",
  "block.minecraft.oxidized_copper_chain": "Oksidēta vara ķēde",
  "block.minecraft.oxidized_copper_chest": "Oksidēta vara lāde",
  "block.minecraft.oxidized_copper_door": "Oksidēta vara durvis",
  "block.minecraft.oxidized_copper_golem_statue": "Oksidēta vara golema statuja",
  "block.minecraft.oxidized_copper_grate": "Oksidēta vara režģis",
  "block.minecraft.oxidized_copper_lantern": "Oksidēta vara laterna",
  "block.minecraft.oxidized_copper_trapdoor": "Oksidēta vara lamatas durvis",
  "block.minecraft.oxidized_cut_copper": "Oksidēts šķelts varš",
  "block.minecraft.oxidized_cut_copper_slab": "Oksidēta šķelta vara plāksne",
  "block.minecraft.oxidized_cut_copper_stairs": "Oksidēti šķelti vara pakāpieni",
  "block.minecraft.oxidized_lightning_rod": "Oksidējies zibensnovedējs",
  "block.minecraft.packed_ice": "Pakots ledus",
  "block.minecraft.packed_mud": "Saspiesti dubļi",
  "block.minecraft.pale_hanging_moss": "Bālas nokarenās sūnas",
  "block.minecraft.pale_moss_block": "Bāla sūnu bloks",
  "block.minecraft.pale_moss_carpet": "Bāls sūnu paklājs",
  "block.minecraft.pale_oak_button": "Bālā ozola poga",
  "block.minecraft.pale_oak_door": "Bālā ozola durvis",
  "block.minecraft.pale_oak_fence": "Bālā ozola žogs",
  "block.minecraft.pale_oak_fence_gate": "Bālā ozola žoga vārti",
  "block.minecraft.pale_oak_hanging_sign": "Iekarināta bālā ozola zīme",
  "block.minecraft.pale_oak_leaves": "Bālā ozola lapas",
  "block.minecraft.pale_oak_log": "Bālā ozola baļķis",
  "block.minecraft.pale_oak_planks": "Bālā ozola dēļi",
  "block.minecraft.pale_oak_pressure_plate": "Bālā ozola spiediena plātne",
  "block.minecraft.pale_oak_sapling": "Bālā ozola stāds",
  "block.minecraft.pale_oak_shelf": "Bālā ozola plaukts",
  "block.minecraft.pale_oak_sign": "Bālā ozola zīme",
  "block.minecraft.pale_oak_slab": "Bālā ozola plāksne",
  "block.minecraft.pale_oak_stairs": "Bālā ozola kāpnes",
  "block.minecraft.pale_oak_trapdoor": "Bālā ozola lūka",
  "block.minecraft.pale_oak_wall_hanging_sign": "Bāla ozola sienas piekarināmā zīme",
  "block.minecraft.pale_oak_wall_sign": "Bāla ozola sienas zīme",
  "block.minecraft.pale_oak_wood": "Bālais ozols",
  "block.minecraft.pearlescent_froglight": "Perlamutra varžu lampa",
  "block.minecraft.peony": "Peonija",
  "block.minecraft.petrified_oak_slab": "Pārakmeņojisies ozola plāksne",
  "block.minecraft.piglin_head": "Piglina galva",
  "block.minecraft.piglin_wall_head": "Piglina galva uz sienas",
  "block.minecraft.pink_banner": "Rozā karogs",
  "block.minecraft.pink_bed": "Rozā gulta",
  "block.minecraft.pink_candle": "Rozā svece",
  "block.minecraft.pink_candle_cake": "Torte ar rozā sveci",
  "block.minecraft.pink_carpet": "Rozā paklājs",
  "block.minecraft.pink_concrete": "Rozā betons",
  "block.minecraft.pink_concrete_powder": "Rozā betona pulveris",
  "block.minecraft.pink_glazed_terracotta": "Rozā glazēta terakota",
  "block.minecraft.pink_petals": "Rozā Ziedlapas",
  "block.minecraft.pink_shulker_box": "Rozā shulker kaste",
  "block.minecraft.pink_stained_glass": "Rozā krāsots stikls",
  "block.minecraft.pink_stained_glass_pane": "Rozā krāsota stikla plāksne",
  "block.minecraft.pink_terracotta": "Rozā terakota",
  "block.minecraft.pink_tulip": "Rozā tulpe",
  "block.minecraft.pink_wool": "Rozā vilna",
  "block.minecraft.piston": "Virzulis",
  "block.minecraft.piston_head": "Virzuļa galva",
  "block.minecraft.pitcher_crop": "Nepentes stāds",
  "block.minecraft.pitcher_plant": "Nepente",
  "block.minecraft.player_head": "Spēlētāja galva",
  "block.minecraft.player_head.named": "%s galva",
  "block.minecraft.player_wall_head": "Spēlētāja galva uz sienas",
  "block.minecraft.podzol": "Podzols",
  "block.minecraft.pointed_dripstone": "Tekošs tekakmens",
  "block.minecraft.polished_andesite": "Pulēts andesīts",
  "block.minecraft.polished_andesite_slab": "Pulēta andesīta plāksne",
  "block.minecraft.polished_andesite_stairs": "Pulētas andesīta kāpnes",
  "block.minecraft.polished_basalt": "Nospodrinātais bazalts",
  "block.minecraft.polished_blackstone": "Pulēts melnakmens",
  "block.minecraft.polished_blackstone_brick_slab": "Pulēta melnakmens ķieģeļu plāksne",
  "block.minecraft.polished_blackstone_brick_stairs": "Pulēta melnakmens ķieģeļu kāpnes",
  "block.minecraft.polished_blackstone_brick_wall": "Pulētu melnakmens ķieģeļu mūris",
  "block.minecraft.polished_blackstone_bricks": "Pulēti Melnakmens Ķieģeļi",
  "block.minecraft.polished_blackstone_button": "Pulēta Melnakmens Poga",
  "block.minecraft.polished_blackstone_pressure_plate": "Pulēta Melnakmens Spiediena Plāksne",
  "block.minecraft.polished_blackstone_slab": "Pulēta melnakmens plāksne",
  "block.minecraft.polished_blackstone_stairs": "Pulēta melnakmens kāpnes",
  "block.minecraft.polished_blackstone_wall": "Pulēta melnakmens mūris",
  "block.minecraft.polished_deepslate": "Pulēts dziļslāneklis",
  "block.minecraft.polished_deepslate_slab": "Pulēta dziļslānekļa plāksne",
  "block.minecraft.polished_deepslate_stairs": "Pulēta dziļslānekļa kāpnes",
  "block.minecraft.polished_deepslate_wall": "Pulēta dziļslānekļa mūris",
  "block.minecraft.polished_diorite": "Pulēts diorīts",
  "block.minecraft.polished_diorite_slab": "Pulēta diorīta plāksne",
  "block.minecraft.polished_diorite_stairs": "Pulētas diorīta kāpnes",
  "block.minecraft.polished_granite": "Pulēts granīts",
  "block.minecraft.polished_granite_slab": "Pulēta granīta plāksne",
  "block.minecraft.polished_granite_stairs": "Pulētas granīta kāpnes",
  "block.minecraft.polished_tuff": "Pulēts Tufs",
  "block.minecraft.polished_tuff_slab": "Pulēta Tufa plāksne",
  "block.minecraft.polished_tuff_stairs": "Pulēta Tufa kāpnes",
  "block.minecraft.polished_tuff_wall": "Pulēta Tufa siena",
  "block.minecraft.poppy": "Magone",
  "block.minecraft.potatoes": "Kartupeļi",
  "block.minecraft.potted_acacia_sapling": "Akācijas stāds puķupodā",
  "block.minecraft.potted_allium": "Sīpoli puķupodā",
  "block.minecraft.potted_azalea_bush": "Acālija puķupodā",
  "block.minecraft.potted_azure_bluet": "Debeszilā rudzupuķe puķupodā",
  "block.minecraft.potted_bamboo": "Bambuss puķupodā",
  "block.minecraft.potted_birch_sapling": "Bērza stāds puķupodā",
  "block.minecraft.potted_blue_orchid": "Zila orhideja puķupodā",
  "block.minecraft.potted_brown_mushroom": "Brūna sēne puķupodā",
  "block.minecraft.potted_cactus": "Kaktus puķupodā",
  "block.minecraft.potted_cherry_sapling": "Ķirša stāds puķupodā",
  "block.minecraft.potted_closed_eyeblossom": "Aizvērts aczieds puķupodā",
  "block.minecraft.potted_cornflower": "Rudzupuķe puķupodā",
  "block.minecraft.potted_crimson_fungus": "Tumšsarkana sēnīte puķupodā",
  "block.minecraft.potted_crimson_roots": "Tumšsarkanas saknes puķupodā",
  "block.minecraft.potted_dandelion": "Pienene puķupodā",
  "block.minecraft.potted_dark_oak_sapling": "Tumšā ozola stāds puķupodā",
  "block.minecraft.potted_dead_bush": "Nokaltis krūms puķupodā",
  "block.minecraft.potted_fern": "Paparde puķupodā",
  "block.minecraft.potted_flowering_azalea_bush": "Ziedoša acālija puķupodā",
  "block.minecraft.potted_golden_dandelion": "Zelta Pienene Puķupodā",
  "block.minecraft.potted_jungle_sapling": "Džungļu koka stāds puķupodā",
  "block.minecraft.potted_lily_of_the_valley": "Maijpuķīte puķupodā",
  "block.minecraft.potted_mangrove_propagule": "Mangroves pumpurs puķupodā",
  "block.minecraft.potted_oak_sapling": "Ozola stāds puķupodā",
  "block.minecraft.potted_open_eyeblossom": "Uzplaucis aczieds puķupodā",
  "block.minecraft.potted_orange_tulip": "Oranža tulpe puķupodā",
  "block.minecraft.potted_oxeye_daisy": "Margrietiņa puķupodā",
  "block.minecraft.potted_pale_oak_sapling": "Bālā ozola stāds puķupodā",
  "block.minecraft.potted_pink_tulip": "Rozā tulpe puķupodā",
  "block.minecraft.potted_poppy": "Magone puķupodā",
  "block.minecraft.potted_red_mushroom": "Sarkana sēne puķupodā",
  "block.minecraft.potted_red_tulip": "Sarkana tulpe puķupodā",
  "block.minecraft.potted_spruce_sapling": "Egles stāds puķupodā",
  "block.minecraft.potted_torchflower": "Lāpu zieds puķupodā",
  "block.minecraft.potted_warped_fungus": "Izlocīta sēnīte puķupodā",
  "block.minecraft.potted_warped_roots": "Izlocītas saknes puķupodā",
  "block.minecraft.potted_white_tulip": "Balta tulpe puķupodā",
  "block.minecraft.potted_wither_rose": "Wither roze puķupodā",
  "block.minecraft.powder_snow": "Drupens sniegs",
  "block.minecraft.powder_snow_cauldron": "Drupena sniega katls",
  "block.minecraft.powered_rail": "Elektriskās sliedes",
  "block.minecraft.prismarine": "Prizmarīns",
  "block.minecraft.prismarine_brick_slab": "Prizmarīna ķieģeļu plāksne",
  "block.minecraft.prismarine_brick_stairs": "Prizmarīna kieģeļu kāpnes",
  "block.minecraft.prismarine_bricks": "Prizmarīna ķieģeļi",
  "block.minecraft.prismarine_slab": "Prizmarīna plāksne",
  "block.minecraft.prismarine_stairs": "Prizmarīna kāpnes",
  "block.minecraft.prismarine_wall": "Prizmarīna mūris",
  "block.minecraft.pumpkin": "Ķirbis",
  "block.minecraft.pumpkin_stem": "Ķirbja stumbrs",
  "block.minecraft.purple_banner": "Violēts karogs",
  "block.minecraft.purple_bed": "Violeta gulta",
  "block.minecraft.purple_candle": "Violeta svece",
  "block.minecraft.purple_candle_cake": "Torte ar violetu sveci",
  "block.minecraft.purple_carpet": "Violets paklājs",
  "block.minecraft.purple_concrete": "Violets betons",
  "block.minecraft.purple_concrete_powder": "Violets betona pulveris",
  "block.minecraft.purple_glazed_terracotta": "Violeta glazēta terakota",
  "block.minecraft.purple_shulker_box": "Violeta shulker kaste",
  "block.minecraft.purple_stained_glass": "Violets krāsots stikls",
  "block.minecraft.purple_stained_glass_pane": "Violeta krāsota stikla plāksne",
  "block.minecraft.purple_terracotta": "Violeta terakota",
  "block.minecraft.purple_wool": "Violeta vilna",
  "block.minecraft.purpur_block": "Purpur bloks",
  "block.minecraft.purpur_pillar": "Purpur pīlārs",
  "block.minecraft.purpur_slab": "Purpur plāksne",
  "block.minecraft.purpur_stairs": "Purpur kāpnes",
  "block.minecraft.quartz_block": "Kvarca bloks",
  "block.minecraft.quartz_bricks": "Kvarca Ķieģeļi",
  "block.minecraft.quartz_pillar": "Kvarca pīlārs",
  "block.minecraft.quartz_slab": "Kvarca plāksne",
  "block.minecraft.quartz_stairs": "Kvarca kāpnes",
  "block.minecraft.rail": "Sliedes",
  "block.minecraft.raw_copper_block": "Nesptrādāta vara bloks",
  "block.minecraft.raw_gold_block": "Neapstrādāta zelta bloks",
  "block.minecraft.raw_iron_block": "Neapstrādāta dzelzs bloks",
  "block.minecraft.red_banner": "Sarkans karogs",
  "block.minecraft.red_bed": "Sarkana gulta",
  "block.minecraft.red_candle": "Sarkana svece",
  "block.minecraft.red_candle_cake": "Torte ar sarkanu sveci",
  "block.minecraft.red_carpet": "Sarkans paklājs",
  "block.minecraft.red_concrete": "Sarkans betons",
  "block.minecraft.red_concrete_powder": "Sarkans betona pulveris",
  "block.minecraft.red_glazed_terracotta": "Sarkana glazēta terakota",
  "block.minecraft.red_mushroom": "Sarkana sēne",
  "block.minecraft.red_mushroom_block": "Sarkano sēņu bloks",
  "block.minecraft.red_nether_brick_slab": "Sarkano Nether ķieģeļu plāksne",
  "block.minecraft.red_nether_brick_stairs": "Sarkano Nether ķieģeļu kāpnes",
  "block.minecraft.red_nether_brick_wall": "Sarkano Nether ķieģeļu mūris",
  "block.minecraft.red_nether_bricks": "Sarkanie Nether ķieģeļi",
  "block.minecraft.red_sand": "Sarkanās smiltis",
  "block.minecraft.red_sandstone": "Sarkanais smilšakmens",
  "block.minecraft.red_sandstone_slab": "Sarkanā smilšakmens plāksne",
  "block.minecraft.red_sandstone_stairs": "Sarkanā smilšakmens kāpnes",
  "block.minecraft.red_sandstone_wall": "Sarkanā smilšakmens mūris",
  "block.minecraft.red_shulker_box": "Sarkana shulker kaste",
  "block.minecraft.red_stained_glass": "Sarkans krāsots stikls",
  "block.minecraft.red_stained_glass_pane": "Sarkana krāsota stikla plāksne",
  "block.minecraft.red_terracotta": "Sarkana terakota",
  "block.minecraft.red_tulip": "Sarkana tulpe",
  "block.minecraft.red_wool": "Sarkana vilna",
  "block.minecraft.redstone_block": "Redstone bloks",
  "block.minecraft.redstone_lamp": "Redstone lampa",
  "block.minecraft.redstone_ore": "Redstone rūda",
  "block.minecraft.redstone_torch": "Redstone lāpa",
  "block.minecraft.redstone_wall_torch": "Redstone sienas lāpa",
  "block.minecraft.redstone_wire": "Redstone vads",
  "block.minecraft.reinforced_deepslate": "Pastiprināts dziļslneklis",
  "block.minecraft.repeater": "Redstone atkārtotājs",
  "block.minecraft.repeating_command_block": "Atkārtojošais komandu bloks",
  "block.minecraft.resin_block": "Sveķu bloks",
  "block.minecraft.resin_brick_slab": "Sveķu ķieģeļu plāksne",
  "block.minecraft.resin_brick_stairs": "Sveķu ķieģeļu mūris",
  "block.minecraft.resin_brick_wall": "Sveķu ķieģeļu mūris",
  "block.minecraft.resin_bricks": "Sveķu ķieģeļi",
  "block.minecraft.resin_clump": "Sveķu pika",
  "block.minecraft.respawn_anchor": "Atdzimšanas enkurs",
  "block.minecraft.rooted_dirt": "Sakņota zeme",
  "block.minecraft.rose_bush": "Rožu krūms",
  "block.minecraft.sand": "Smiltis",
  "block.minecraft.sandstone": "Smilšakmens",
  "block.minecraft.sandstone_slab": "Smilšakmens plāksne",
  "block.minecraft.sandstone_stairs": "Smilšakmens kāpnes",
  "block.minecraft.sandstone_wall": "Smilšakmens mūris",
  "block.minecraft.scaffolding": "Sastatnes",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Sculk katalizators",
  "block.minecraft.sculk_sensor": "Sculk sensors",
  "block.minecraft.sculk_shrieker": "Sculk kliedzējs",
  "block.minecraft.sculk_vein": "Sculk vēna",
  "block.minecraft.sea_lantern": "Jūras laterna",
  "block.minecraft.sea_pickle": "Jūras gurķis",
  "block.minecraft.seagrass": "Jūraszāle",
  "block.minecraft.set_spawn": "Atdzimšanas vieta iestatīta",
  "block.minecraft.short_dry_grass": "Īsā sausā zāle",
  "block.minecraft.short_grass": "Īsa zāle",
  "block.minecraft.shroomlight": "Sēnesgaisma",
  "block.minecraft.shulker_box": "Shulker kaste",
  "block.minecraft.skeleton_skull": "Skeleta gavlaskauss",
  "block.minecraft.skeleton_wall_skull": "Skeleta galvaskauss uz sienas",
  "block.minecraft.slime_block": "Gļotu bloks",
  "block.minecraft.small_amethyst_bud": "Mazs ametista kristāls",
  "block.minecraft.small_dripleaf": "Jauna krītlapa",
  "block.minecraft.smithing_table": "Kalēja galds",
  "block.minecraft.smoker": "Kūpinātava",
  "block.minecraft.smooth_basalt": "Gluds bazalts",
  "block.minecraft.smooth_quartz": "Gludais kvarca bloks",
  "block.minecraft.smooth_quartz_slab": "Gluda kvarca plāksne",
  "block.minecraft.smooth_quartz_stairs": "Gludas kvarca kāpnes",
  "block.minecraft.smooth_red_sandstone": "Gludais sarkanais smilšakmens",
  "block.minecraft.smooth_red_sandstone_slab": "Gluda sarkanā smilšakmens plāksne",
  "block.minecraft.smooth_red_sandstone_stairs": "Gludas sarkanā smilšakmens kāpnes",
  "block.minecraft.smooth_sandstone": "Gludais Smilšakmems",
  "block.minecraft.smooth_sandstone_slab": "Gluda smilšakmens plāksne",
  "block.minecraft.smooth_sandstone_stairs": "Gludas smilšakmens kāpnes",
  "block.minecraft.smooth_stone": "Gludais akmens",
  "block.minecraft.smooth_stone_slab": "Gludā akmens plāksne",
  "block.minecraft.sniffer_egg": "Ošņātāja ola",
  "block.minecraft.snow": "Sniegs",
  "block.minecraft.snow_block": "Sniega bloks",
  "block.minecraft.soul_campfire": "Dvēseļu ugunskurs",
  "block.minecraft.soul_fire": "Dvēseles Uguns",
  "block.minecraft.soul_lantern": "Dvēseļu laterna",
  "block.minecraft.soul_sand": "Dvēseļu smiltis",
  "block.minecraft.soul_soil": "Dvēseļu augsne",
  "block.minecraft.soul_torch": "Dvēseļu lāpa",
  "block.minecraft.soul_wall_torch": "Dvēseļu sienas lāpa",
  "block.minecraft.spawn.not_valid": "Jums nav māju gultas vai uzlādēta atdzimšanas enkura, vai tas tika iznīcināts",
  "block.minecraft.spawner": "Briesmoņu radītājs",
  "block.minecraft.spawner.desc1": "Mijiedarbojoties ar radīšanas olu:",
  "block.minecraft.spawner.desc2": "Uzstāda radības tipu",
  "block.minecraft.sponge": "Sūklis",
  "block.minecraft.spore_blossom": "Sporu zieds",
  "block.minecraft.spruce_button": "Egles poga",
  "block.minecraft.spruce_door": "Egles durvis",
  "block.minecraft.spruce_fence": "Egles žogs",
  "block.minecraft.spruce_fence_gate": "Egles žoga vārti",
  "block.minecraft.spruce_hanging_sign": "Iekarināta egles zīme",
  "block.minecraft.spruce_leaves": "Egles lapas",
  "block.minecraft.spruce_log": "Egles baļķis",
  "block.minecraft.spruce_planks": "Egles dēļi",
  "block.minecraft.spruce_pressure_plate": "Egles spiediena plātne",
  "block.minecraft.spruce_sapling": "Egles stāds",
  "block.minecraft.spruce_shelf": "Egles plaukts",
  "block.minecraft.spruce_sign": "Egles zīme",
  "block.minecraft.spruce_slab": "Egles plāksne",
  "block.minecraft.spruce_stairs": "Egles kāpnes",
  "block.minecraft.spruce_trapdoor": "Egles lūka",
  "block.minecraft.spruce_wall_hanging_sign": "Iekarināta egles sienas zīme",
  "block.minecraft.spruce_wall_sign": "Egles sienas zīme",
  "block.minecraft.spruce_wood": "Egles koks",
  "block.minecraft.sticky_piston": "Lipīgs virzulis",
  "block.minecraft.stone": "Akmens",
  "block.minecraft.stone_brick_slab": "Akmens ķieģeļu plāksne",
  "block.minecraft.stone_brick_stairs": "Akmens ķieģeļu kāpnes",
  "block.minecraft.stone_brick_wall": "Akmens ķieģeļu mūris",
  "block.minecraft.stone_bricks": "Akmens ķieģeļi",
  "block.minecraft.stone_button": "Akmens poga",
  "block.minecraft.stone_pressure_plate": "Akmens spiediena plātne",
  "block.minecraft.stone_slab": "Akmens plāksne",
  "block.minecraft.stone_stairs": "Akmens kāpnes",
  "block.minecraft.stonecutter": "Akmeņkalis",
  "block.minecraft.stripped_acacia_log": "Nomizots akācijas baļķis",
  "block.minecraft.stripped_acacia_wood": "Nomizots akācijas koks",
  "block.minecraft.stripped_bamboo_block": "Nomizots bambusa bloks",
  "block.minecraft.stripped_birch_log": "Nomizots bērza baļķis",
  "block.minecraft.stripped_birch_wood": "Nomizots bērza koks",
  "block.minecraft.stripped_cherry_log": "Nomizots ķirša baļķis",
  "block.minecraft.stripped_cherry_wood": "Nomizots ķirša koks",
  "block.minecraft.stripped_crimson_hyphae": "Nomizotas tumšsarkanas hifas",
  "block.minecraft.stripped_crimson_stem": "Nomizots tumšsarkans kāts",
  "block.minecraft.stripped_dark_oak_log": "Nomizots tumšā ozola baļķis",
  "block.minecraft.stripped_dark_oak_wood": "Nomizots tumšais ozols",
  "block.minecraft.stripped_jungle_log": "Nomizots džungļu koka baļķis",
  "block.minecraft.stripped_jungle_wood": "Nomizots džungļu koks",
  "block.minecraft.stripped_mangrove_log": "Nomizots mangroves baļķis",
  "block.minecraft.stripped_mangrove_wood": "Nomizots mangroves koks",
  "block.minecraft.stripped_oak_log": "Nomizots ozola baļķis",
  "block.minecraft.stripped_oak_wood": "Nomizots ozols",
  "block.minecraft.stripped_pale_oak_log": "Nomizots bālā ozola baļķis",
  "block.minecraft.stripped_pale_oak_wood": "Nomizots bālais ozols",
  "block.minecraft.stripped_spruce_log": "Nomizots egles baļķis",
  "block.minecraft.stripped_spruce_wood": "Nomizots egles koks",
  "block.minecraft.stripped_warped_hyphae": "Nomizotas izlocītas hifas",
  "block.minecraft.stripped_warped_stem": "Nomizots Izlocīts kāts",
  "block.minecraft.structure_block": "Struktūras bloks",
  "block.minecraft.structure_void": "Struktūras tukšums",
  "block.minecraft.sugar_cane": "Cukurniedres",
  "block.minecraft.sunflower": "Saulespuķe",
  "block.minecraft.suspicious_gravel": "Aizdomīga grants",
  "block.minecraft.suspicious_sand": "Aizdomīgas smiltis",
  "block.minecraft.sweet_berry_bush": "Saldo ogu krūms",
  "block.minecraft.tall_dry_grass": "Garā sausā zāle",
  "block.minecraft.tall_grass": "Gara zāle",
  "block.minecraft.tall_seagrass": "Garā jūraszāle",
  "block.minecraft.target": "Mērķis",
  "block.minecraft.terracotta": "Terakota",
  "block.minecraft.test_block": "Testa Bloks",
  "block.minecraft.test_instance_block": "Testa instances bloks",
  "block.minecraft.tinted_glass": "Tonēts stikls",
  "block.minecraft.tnt": "Dinamīts",
  "block.minecraft.tnt.disabled": "Dinamītu sprādzieni ir izslēgti",
  "block.minecraft.torch": "Lāpa",
  "block.minecraft.torchflower": "Lāpu zieds",
  "block.minecraft.torchflower_crop": "Lāpu zieda augs",
  "block.minecraft.trapped_chest": "Lamatu lāde",
  "block.minecraft.trial_spawner": "Izaicinājuma radītājs",
  "block.minecraft.tripwire": "Lamatu aukla",
  "block.minecraft.tripwire_hook": "Lamatu āķis",
  "block.minecraft.tube_coral": "Caurules korallis",
  "block.minecraft.tube_coral_block": "Caurules koraļļu bloks",
  "block.minecraft.tube_coral_fan": "Caurules koraļļa spārns",
  "block.minecraft.tube_coral_wall_fan": "Caurules koraļļa sienas vēdeklis",
  "block.minecraft.tuff": "Tufs",
  "block.minecraft.tuff_brick_slab": "Tufa ķieģeļu plāksne",
  "block.minecraft.tuff_brick_stairs": "Tufa ķieģeļu kāpnes",
  "block.minecraft.tuff_brick_wall": "Tufa ķieģeļu siena",
  "block.minecraft.tuff_bricks": "Tufa ķieģeļi",
  "block.minecraft.tuff_slab": "Tufa plāksne",
  "block.minecraft.tuff_stairs": "Tufa kāpnes",
  "block.minecraft.tuff_wall": "Tufa siena",
  "block.minecraft.turtle_egg": "Bruņurupuča ola",
  "block.minecraft.twisting_vines": "Sagrozītais vīteņaugs",
  "block.minecraft.twisting_vines_plant": "Sagrieztais vīteņaugs",
  "block.minecraft.vault": "Seifs",
  "block.minecraft.verdant_froglight": "Malahītzaļa varžu lampa",
  "block.minecraft.vine": "Vīnoglāji",
  "block.minecraft.void_air": "Tukšuma gaiss",
  "block.minecraft.wall_torch": "Sienas lāpa",
  "block.minecraft.warped_button": "Izlocīta poga",
  "block.minecraft.warped_door": "Izlocītas durvis",
  "block.minecraft.warped_fence": "Izlocīts žogs",
  "block.minecraft.warped_fence_gate": "Izlocīta žoga vārti",
  "block.minecraft.warped_fungus": "Izlocīta sēnīte",
  "block.minecraft.warped_hanging_sign": "Iekarināta izlocīta zīme",
  "block.minecraft.warped_hyphae": "Izlocītas hifas",
  "block.minecraft.warped_nylium": "Izlocīts nīlijs",
  "block.minecraft.warped_planks": "Izlocīti dēļi",
  "block.minecraft.warped_pressure_plate": "Izlocīta spiediena plāksne",
  "block.minecraft.warped_roots": "Izlocītas saknes",
  "block.minecraft.warped_shelf": "Izlocīts plaukts",
  "block.minecraft.warped_sign": "Izlocīta zīme",
  "block.minecraft.warped_slab": "Izlocīta plāksne",
  "block.minecraft.warped_stairs": "Izlocītas kāpnes",
  "block.minecraft.warped_stem": "Izlocīts kāts",
  "block.minecraft.warped_trapdoor": "Izlocīta lūka",
  "block.minecraft.warped_wall_hanging_sign": "Iekarināta izlocīta sienas zīme",
  "block.minecraft.warped_wall_sign": "Izlocīta sienas zīme",
  "block.minecraft.warped_wart_block": "Izlocīts kārpu bloks",
  "block.minecraft.water": "Ūdens",
  "block.minecraft.water_cauldron": "Ūdens katls",
  "block.minecraft.waxed_chiseled_copper": "Vaskotais kaltētais varš",
  "block.minecraft.waxed_copper_bars": "Vaskotas vara restes",
  "block.minecraft.waxed_copper_block": "Vaskots vara bloks",
  "block.minecraft.waxed_copper_bulb": "Vaskota vara spuldze",
  "block.minecraft.waxed_copper_chain": "Vaskota vara ķēde",
  "block.minecraft.waxed_copper_chest": "Vaskota vara lāde",
  "block.minecraft.waxed_copper_door": "Vaskota vara durvis",
  "block.minecraft.waxed_copper_golem_statue": "Vaskota vara golema statuja",
  "block.minecraft.waxed_copper_grate": "Vaskotā vara režģis",
  "block.minecraft.waxed_copper_lantern": "Vaskota vara laterna",
  "block.minecraft.waxed_copper_trapdoor": "Vaskotā vara lamatas",
  "block.minecraft.waxed_cut_copper": "Vaskots šķelts varš",
  "block.minecraft.waxed_cut_copper_slab": "Vaskota šķelta vara plāksne",
  "block.minecraft.waxed_cut_copper_stairs": "Vaskoti šķelti vara pakāpieni",
  "block.minecraft.waxed_exposed_chiseled_copper": "Vaskotais atsegtais kaltētais varš",
  "block.minecraft.waxed_exposed_copper": "Vaskots atsegts varš",
  "block.minecraft.waxed_exposed_copper_bars": "Vaskotas atsegtas vara restes",
  "block.minecraft.waxed_exposed_copper_bulb": "Vaskota atklāta vara spuldze",
  "block.minecraft.waxed_exposed_copper_chain": "Vaskota atsegta vara ķēde",
  "block.minecraft.waxed_exposed_copper_chest": "Vaskota atsegta vara lāde",
  "block.minecraft.waxed_exposed_copper_door": "Vaskotās atklātās vara durvis",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Vaskota atsegta vara golema statuja",
  "block.minecraft.waxed_exposed_copper_grate": "Vaskotās atklātās vara režģa restes",
  "block.minecraft.waxed_exposed_copper_lantern": "Vaskota atsegta vara laterna",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Vaskotās atsegtas vara lūka",
  "block.minecraft.waxed_exposed_cut_copper": "Vaskots šķelts atsegts varš",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Vaskota atsegta šķelta vara plāksne",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Vaskoti atsegta šķelta vara pakāpieni",
  "block.minecraft.waxed_exposed_lightning_rod": "Vaskots atsegts zibensnovedējs",
  "block.minecraft.waxed_lightning_rod": "Vaskots zibensnovedējs",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Vaskots oksidēts slīpēts varš",
  "block.minecraft.waxed_oxidized_copper": "Vaskots oksidēts varš",
  "block.minecraft.waxed_oxidized_copper_bars": "Vaskotas oksidētas vara restes",
  "block.minecraft.waxed_oxidized_copper_bulb": "Vaskota oksidēta vara spuldze",
  "block.minecraft.waxed_oxidized_copper_chain": "Vaskota oksidēta vara ķēde",
  "block.minecraft.waxed_oxidized_copper_chest": "Vaskota oksidēta vara lāde",
  "block.minecraft.waxed_oxidized_copper_door": "Vaskotas oksidētas vara durvis",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Vaskota oksidēta vara golema statuja",
  "block.minecraft.waxed_oxidized_copper_grate": "Vaskots oksidēts slīpēta vara režģis",
  "block.minecraft.waxed_oxidized_copper_lantern": "Vaskota oksidēta vara laterna",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Vaskota oksidēta slīpēta vara lūka",
  "block.minecraft.waxed_oxidized_cut_copper": "Vaskots oksidēts šķelts varš",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Vaskota oksidēta šķelta vara plāksne",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Vaskoti oksidēta šķelta vara pakāpieni",
  "block.minecraft.waxed_oxidized_lightning_rod": "Vaskots oksidējies zibensnovedējs",
  "block.minecraft.waxed_weathered_chiseled_copper": "Vaskots apsūbējis slīpēts varš",
  "block.minecraft.waxed_weathered_copper": "Vaskots apsūbējis varš",
  "block.minecraft.waxed_weathered_copper_bars": "Vaskotas apsūbējušas vara restes",
  "block.minecraft.waxed_weathered_copper_bulb": "Vaskota apsūbējusi vara spuldze",
  "block.minecraft.waxed_weathered_copper_chain": "Vaskota apsūbējusi vara ķēde",
  "block.minecraft.waxed_weathered_copper_chest": "Vaskota apsūbējusi vara lāde",
  "block.minecraft.waxed_weathered_copper_door": "Vaskotas apsūbējušas vara durvis",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Vaskota apsūbējusi vara golema statuja",
  "block.minecraft.waxed_weathered_copper_grate": "Vaskots apsūbējis vara režģis",
  "block.minecraft.waxed_weathered_copper_lantern": "Vaskota apsūbējusi vara laterna",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Vaskota apsūbējējusi vara lūka",
  "block.minecraft.waxed_weathered_cut_copper": "Vaskots apsūbējis šķelts varš",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Vaskota apsūbējuša šķelta vara plāksne",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Vaskoti apsūbējuša šķelta vara pakāpieni",
  "block.minecraft.waxed_weathered_lightning_rod": "Vaskots apsūbējis zibensnovedējs",
  "block.minecraft.weathered_chiseled_copper": "Apsūbējis slīpēts varš",
  "block.minecraft.weathered_copper": "Apsūbējis varš",
  "block.minecraft.weathered_copper_bars": "Apsūbējusšas vara restes",
  "block.minecraft.weathered_copper_bulb": "Apsūbējusi vara spuldze",
  "block.minecraft.weathered_copper_chain": "Apsūbējusi vara ķēde",
  "block.minecraft.weathered_copper_chest": "Apsūbējusi vara lāde",
  "block.minecraft.weathered_copper_door": "Apsūbējušas vara durvis",
  "block.minecraft.weathered_copper_golem_statue": "Apsūbējusi vara golema statuja",
  "block.minecraft.weathered_copper_grate": "Apsūbējis vara režģis",
  "block.minecraft.weathered_copper_lantern": "Apsūbējusi vara laterna",
  "block.minecraft.weathered_copper_trapdoor": "Apsūbējusi vara lūka",
  "block.minecraft.weathered_cut_copper": "Apsūbējis šķelts varš",
  "block.minecraft.weathered_cut_copper_slab": "Apsūbējusi šķelta vara plāksne",
  "block.minecraft.weathered_cut_copper_stairs": "Apsūbējuši šķelti vara pakāpieni",
  "block.minecraft.weathered_lightning_rod": "Apsūbējis zibensnovedējs",
  "block.minecraft.weeping_vines": "Raudošs vīteņaugs",
  "block.minecraft.weeping_vines_plant": "Raudošais vīteņaugs",
  "block.minecraft.wet_sponge": "Mitrs sūklis",
  "block.minecraft.wheat": "Kviešu labība",
  "block.minecraft.white_banner": "Balts karogs",
  "block.minecraft.white_bed": "Balta gulta",
  "block.minecraft.white_candle": "Balta svece",
  "block.minecraft.white_candle_cake": "Torte ar baltu sveci",
  "block.minecraft.white_carpet": "Balts paklājs",
  "block.minecraft.white_concrete": "Balts betons",
  "block.minecraft.white_concrete_powder": "Balts betona pulveris",
  "block.minecraft.white_glazed_terracotta": "Balta glazēta terakota",
  "block.minecraft.white_shulker_box": "Balta shulker kaste",
  "block.minecraft.white_stained_glass": "Balts krāsots stikls",
  "block.minecraft.white_stained_glass_pane": "Balta krāsota stikla plāksne",
  "block.minecraft.white_terracotta": "Balta terakota",
  "block.minecraft.white_tulip": "Balta tulpe",
  "block.minecraft.white_wool": "Balta vilna",
  "block.minecraft.wildflowers": "Savvaļas puķes",
  "block.minecraft.wither_rose": "Wither roze",
  "block.minecraft.wither_skeleton_skull": "Wither skeleta galvaskauss",
  "block.minecraft.wither_skeleton_wall_skull": "Wither skeleta galvaskauss uz sienas",
  "block.minecraft.yellow_banner": "Dzeltens karogs",
  "block.minecraft.yellow_bed": "Dzeltena gulta",
  "block.minecraft.yellow_candle": "Dzeltena svece",
  "block.minecraft.yellow_candle_cake": "Torte ar dzeltenu sveci",
  "block.minecraft.yellow_carpet": "Dzeltens paklājs",
  "block.minecraft.yellow_concrete": "Dzeltens betons",
  "block.minecraft.yellow_concrete_powder": "Dzeltens betona pulveris",
  "block.minecraft.yellow_glazed_terracotta": "Dzeltena glazēta terakota",
  "block.minecraft.yellow_shulker_box": "Dzeltena shulker kaste",
  "block.minecraft.yellow_stained_glass": "Dzeltens krāsots stikls",
  "block.minecraft.yellow_stained_glass_pane": "Dzeltena krāsota stikla plāksne",
  "block.minecraft.yellow_terracotta": "Dzeltena terakota",
  "block.minecraft.yellow_wool": "Dzeltena vilna",
  "block.minecraft.zombie_head": "Zombija galva",
  "block.minecraft.zombie_wall_head": "Zombija galva uz sienas",
  "item.minecraft.acacia_boat": "Akācijas laiva",
  "item.minecraft.acacia_chest_boat": "Akācijas laiva ar lādi",
  "item.minecraft.allay_spawn_egg": "Allaja radīšanas ola",
  "item.minecraft.amethyst_shard": "Ametista lauska",
  "item.minecraft.angler_pottery_shard": "Makšķernieka keramikas lauska",
  "item.minecraft.angler_pottery_sherd": "Makšķernieka keramikas šķemba",
  "item.minecraft.apple": "Ābols",
  "item.minecraft.archer_pottery_shard": "Strēlnieka keramikas lauska",
  "item.minecraft.archer_pottery_sherd": "Strēlnieka keramikas šķemba",
  "item.minecraft.armadillo_scute": "Bruņneša čaula",
  "item.minecraft.armadillo_spawn_egg": "Bruņneša radīšanas ola",
  "item.minecraft.armor_stand": "Bruņu statīvs",
  "item.minecraft.arms_up_pottery_shard": "Paceltu roku keramikas lauska",
  "item.minecraft.arms_up_pottery_sherd": "Paceltu roku keramikas šķemba",
  "item.minecraft.arrow": "Bulta",
  "item.minecraft.axolotl_bucket": "Spainis ar aksolotlu",
  "item.minecraft.axolotl_spawn_egg": "Aksolotla radīšanas ola",
  "item.minecraft.baked_potato": "Cepts katrupelis",
  "item.minecraft.bamboo_chest_raft": "Bambusa plosts ar lādi",
  "item.minecraft.bamboo_raft": "Bambusa plosts",
  "item.minecraft.bat_spawn_egg": "Sikspārņa radīšanas ola",
  "item.minecraft.bee_spawn_egg": "Bites radīšanas ola",
  "item.minecraft.beef": "Jēla liellopa gaļa",
  "item.minecraft.beetroot": "Biete",
  "item.minecraft.beetroot_seeds": "Biešu sēklas",
  "item.minecraft.beetroot_soup": "Biešu zupa",
  "item.minecraft.birch_boat": "Bērza laiva",
  "item.minecraft.birch_chest_boat": "Bērza laiva ar lādi",
  "item.minecraft.black_bundle": "Melns saišķis",
  "item.minecraft.black_dye": "Melna krāsa",
  "item.minecraft.black_harness": "Melns iejūgs",
  "item.minecraft.blade_pottery_shard": "Asmens keramikas lauska",
  "item.minecraft.blade_pottery_sherd": "Asmens keramikas šķemba",
  "item.minecraft.blaze_powder": "Liesmu pulveris",
  "item.minecraft.blaze_rod": "Liesmu stienis",
  "item.minecraft.blaze_spawn_egg": "Liesmekļa radīšanas ola",
  "item.minecraft.blue_bundle": "Zils saišķis",
  "item.minecraft.blue_dye": "Zila krāsa",
  "item.minecraft.blue_egg": "Zilā ola",
  "item.minecraft.blue_harness": "Zils iejūgs",
  "item.minecraft.bogged_spawn_egg": "Purvaiņa radīšanas ola",
  "item.minecraft.bolt_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Skrūvju bruņu apdare",
  "item.minecraft.bone": "Kauls",
  "item.minecraft.bone_meal": "Kaulu milti",
  "item.minecraft.book": "Grāmata",
  "item.minecraft.bordure_indented_banner_pattern": "Robotas apmales karoga raksts",
  "item.minecraft.bow": "Loks",
  "item.minecraft.bowl": "Bļoda",
  "item.minecraft.bread": "Maize",
  "item.minecraft.breeze_rod": "Vēsmas stienis",
  "item.minecraft.breeze_spawn_egg": "Vēsmas radīšanas ola",
  "item.minecraft.brewer_pottery_shard": "Brūvnieka keramikas lauska",
  "item.minecraft.brewer_pottery_sherd": "Brūvnieka keramikas šķemba",
  "item.minecraft.brewing_stand": "Brūvēšanas statīvs",
  "item.minecraft.brick": "Ķieģelis",
  "item.minecraft.brown_bundle": "Brūns saišķis",
  "item.minecraft.brown_dye": "Brūna krāsa",
  "item.minecraft.brown_egg": "Brūnā ola",
  "item.minecraft.brown_harness": "Brūns iejūgs",
  "item.minecraft.brush": "Birste",
  "item.minecraft.bucket": "Spainis",
  "item.minecraft.bundle": "Saišķis",
  "item.minecraft.bundle.empty": "Tukšs",
  "item.minecraft.bundle.empty.description": "Var saturēt dažāda veida priekšmetus",
  "item.minecraft.bundle.full": "Pilns",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Dedzināšanas keramikas lauska",
  "item.minecraft.burn_pottery_sherd": "Dedzināšanas keramikas šķemba",
  "item.minecraft.camel_husk_spawn_egg": "Izžuvušā Kamieļa Radīšanas Ola",
  "item.minecraft.camel_spawn_egg": "Kamieļa radīšanas ola",
  "item.minecraft.carrot": "Burkāns",
  "item.minecraft.carrot_on_a_stick": "Burkāns uz kociņa",
  "item.minecraft.cat_spawn_egg": "Kaķa radīšanas ola",
  "item.minecraft.cauldron": "Katls",
  "item.minecraft.cave_spider_spawn_egg": "Alu zirnekļa radīšanas ola",
  "item.minecraft.chainmail_boots": "Ķēžu zābaki",
  "item.minecraft.chainmail_chestplate": "Ķēžu bruņas",
  "item.minecraft.chainmail_helmet": "Ķēžu ķivere",
  "item.minecraft.chainmail_leggings": "Ķēžu bikses",
  "item.minecraft.charcoal": "Kokogles",
  "item.minecraft.cherry_boat": "Ķirša laiva",
  "item.minecraft.cherry_chest_boat": "Ķirša laiva ar lādi",
  "item.minecraft.chest_minecart": "Vagons ar lādi",
  "item.minecraft.chicken": "Jēla vista",
  "item.minecraft.chicken_spawn_egg": "Vistas radīšanas ola",
  "item.minecraft.chorus_fruit": "Kora auglis",
  "item.minecraft.clay_ball": "Māla pika",
  "item.minecraft.clock": "Pulkstenis",
  "item.minecraft.coal": "Ogles",
  "item.minecraft.coast_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Piekrastes bruņu apdare",
  "item.minecraft.cocoa_beans": "Kakao pupiņas",
  "item.minecraft.cod": "Jēla menca",
  "item.minecraft.cod_bucket": "Mencas spainis",
  "item.minecraft.cod_spawn_egg": "Mencas radīšanas ola",
  "item.minecraft.command_block_minecart": "Vagons ar komandu bloku",
  "item.minecraft.compass": "Kompass",
  "item.minecraft.cooked_beef": "Bifšteks",
  "item.minecraft.cooked_chicken": "Cepta vista",
  "item.minecraft.cooked_cod": "Cepta menca",
  "item.minecraft.cooked_mutton": "Cepta aitas gaļa",
  "item.minecraft.cooked_porkchop": "Cepta cūkgaļa",
  "item.minecraft.cooked_rabbit": "Cepta truša gaļa",
  "item.minecraft.cooked_salmon": "Cepts lasis",
  "item.minecraft.cookie": "Cepums",
  "item.minecraft.copper_axe": "Vara Cirvis",
  "item.minecraft.copper_boots": "Vara Zābaki",
  "item.minecraft.copper_chestplate": "Vara Bruņas",
  "item.minecraft.copper_golem_spawn_egg": "Vara Golema Radīšanas Ola",
  "item.minecraft.copper_helmet": "Vara Ķivere",
  "item.minecraft.copper_hoe": "Vara Kaplis",
  "item.minecraft.copper_horse_armor": "Vara Zirga Bruņas",
  "item.minecraft.copper_ingot": "Vara stienis",
  "item.minecraft.copper_leggings": "Vara Bikses",
  "item.minecraft.copper_nautilus_armor": "Vara Nautila Bruņas",
  "item.minecraft.copper_nugget": "Vara gabals",
  "item.minecraft.copper_pickaxe": "Vara Cirtnis",
  "item.minecraft.copper_shovel": "Vara Lāpsta",
  "item.minecraft.copper_spear": "Vara Šķēps",
  "item.minecraft.copper_sword": "Vara Zobens",
  "item.minecraft.cow_spawn_egg": "Govs radīšanas ola",
  "item.minecraft.creaking_spawn_egg": "Čīktoņa radīšanas ola",
  "item.minecraft.creeper_banner_pattern": "Karoga raksts",
  "item.minecraft.creeper_banner_pattern.desc": "Creeper lādiņš",
  "item.minecraft.creeper_banner_pattern.new": "Creeper lādiņa karoga raksts",
  "item.minecraft.creeper_spawn_egg": "Creeper radīšanas ola",
  "item.minecraft.crossbow": "Arbalets",
  "item.minecraft.crossbow.projectile": "Šāviņš:",
  "item.minecraft.crossbow.projectile.multiple": "Šāviņš: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Šāviņš: %s",
  "item.minecraft.cyan_bundle": "Ciāns saišķis",
  "item.minecraft.cyan_dye": "Ciāna krāsa",
  "item.minecraft.cyan_harness": "Ciāns iejūgs",
  "item.minecraft.danger_pottery_shard": "Briesmu keramikas lauska",
  "item.minecraft.danger_pottery_sherd": "Briesmu keramikas šķemba",
  "item.minecraft.dark_oak_boat": "Tumšā ozola laiva",
  "item.minecraft.dark_oak_chest_boat": "Tumšā ozola laiva ar lādi",
  "item.minecraft.debug_stick": "Atkļūdošanas kociņš",
  "item.minecraft.debug_stick.empty": "%s nav rekvizītu",
  "item.minecraft.debug_stick.select": "izvēlēts \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "%s uz %s",
  "item.minecraft.diamond": "Dimants",
  "item.minecraft.diamond_axe": "Dimanta cirvis",
  "item.minecraft.diamond_boots": "Dimanta zābaki",
  "item.minecraft.diamond_chestplate": "Dimanta bruņas",
  "item.minecraft.diamond_helmet": "Dimanta ķivere",
  "item.minecraft.diamond_hoe": "Dimanta kaplis",
  "item.minecraft.diamond_horse_armor": "Dimanta zirgu bruņas",
  "item.minecraft.diamond_leggings": "Dimanta bikses",
  "item.minecraft.diamond_nautilus_armor": "Dimanta Nautila Bruņas",
  "item.minecraft.diamond_pickaxe": "Dimanta cirtnis",
  "item.minecraft.diamond_shovel": "Dimanta lāpsta",
  "item.minecraft.diamond_spear": "Dimanta Šķēps",
  "item.minecraft.diamond_sword": "Dimanta zobens",
  "item.minecraft.disc_fragment_5": "Diska fragments",
  "item.minecraft.disc_fragment_5.desc": "Mūzikas disks - 5",
  "item.minecraft.dolphin_spawn_egg": "Delfīna radīšanas ola",
  "item.minecraft.donkey_spawn_egg": "Ēzeļa radīšanas ola",
  "item.minecraft.dragon_breath": "Pūķa elpa",
  "item.minecraft.dried_kelp": "Kaltētas brūnaļģes",
  "item.minecraft.drowned_spawn_egg": "Slīkoņa radīšanas ola",
  "item.minecraft.dune_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Kāpu bruņu apdare",
  "item.minecraft.echo_shard": "Atblass lauska",
  "item.minecraft.egg": "Ola",
  "item.minecraft.elder_guardian_spawn_egg": "Vecākā sarga radīšanas ola",
  "item.minecraft.elytra": "Elitra",
  "item.minecraft.emerald": "Smaragds",
  "item.minecraft.enchanted_book": "Uzlabota grāmata",
  "item.minecraft.enchanted_golden_apple": "Uzlabots zelta ābols",
  "item.minecraft.end_crystal": "End kristāls",
  "item.minecraft.ender_dragon_spawn_egg": "Ender pūķa radīšanas ola",
  "item.minecraft.ender_eye": "Ender acs",
  "item.minecraft.ender_pearl": "Ender pērle",
  "item.minecraft.enderman_spawn_egg": "Enderman radīšanas ola",
  "item.minecraft.endermite_spawn_egg": "Endermite radīšanas ola",
  "item.minecraft.evoker_spawn_egg": "Evokera radīšanas ola",
  "item.minecraft.experience_bottle": "Burvestību pudele",
  "item.minecraft.explorer_pottery_shard": "Pētnieka keramikas lauska",
  "item.minecraft.explorer_pottery_sherd": "Pētnieka keramikas šķemba",
  "item.minecraft.eye_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Acu bruņu apdare",
  "item.minecraft.feather": "Spalva",
  "item.minecraft.fermented_spider_eye": "Fermentēta zirnekļa acs",
  "item.minecraft.field_masoned_banner_pattern": "Mūrēta lauka karoga raksts",
  "item.minecraft.filled_map": "Karte",
  "item.minecraft.fire_charge": "Ugunsbumba",
  "item.minecraft.firework_rocket": "Salūta raķete",
  "item.minecraft.firework_rocket.flight": "Lidojuma ilgums:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Salūta zvaigzne",
  "item.minecraft.firework_star.black": "Melns",
  "item.minecraft.firework_star.blue": "Zils",
  "item.minecraft.firework_star.brown": "Brūns",
  "item.minecraft.firework_star.custom_color": "Pielāgota",
  "item.minecraft.firework_star.cyan": "Ciāns",
  "item.minecraft.firework_star.fade_to": "Mainīt krāsu uz",
  "item.minecraft.firework_star.flicker": "Mirdzums",
  "item.minecraft.firework_star.gray": "Pelēks",
  "item.minecraft.firework_star.green": "Zaļš",
  "item.minecraft.firework_star.light_blue": "Gaiši zils",
  "item.minecraft.firework_star.light_gray": "Gaiši pelēks",
  "item.minecraft.firework_star.lime": "Gaiši zaļš",
  "item.minecraft.firework_star.magenta": "Fuksīns",
  "item.minecraft.firework_star.orange": "Oranžs",
  "item.minecraft.firework_star.pink": "Rozā",
  "item.minecraft.firework_star.purple": "Violets",
  "item.minecraft.firework_star.red": "Sarkans",
  "item.minecraft.firework_star.shape": "Nezināma forma",
  "item.minecraft.firework_star.shape.burst": "Eksplozija",
  "item.minecraft.firework_star.shape.creeper": "Creeper forma",
  "item.minecraft.firework_star.shape.large_ball": "Liela bumba",
  "item.minecraft.firework_star.shape.small_ball": "Maza bumba",
  "item.minecraft.firework_star.shape.star": "Zvaigznes forma",
  "item.minecraft.firework_star.trail": "Pēdas",
  "item.minecraft.firework_star.white": "Balts",
  "item.minecraft.firework_star.yellow": "Dzeltens",
  "item.minecraft.fishing_rod": "Makšķere",
  "item.minecraft.flint": "Krams",
  "item.minecraft.flint_and_steel": "Krams un dzelzs",
  "item.minecraft.flow_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Plūsmas bruņu ornaments",
  "item.minecraft.flow_banner_pattern": "Karoga raksts",
  "item.minecraft.flow_banner_pattern.desc": "Plūsma",
  "item.minecraft.flow_banner_pattern.new": "Plūsmas karoga raksts",
  "item.minecraft.flow_pottery_sherd": "Plūsmas keramikas šķemba",
  "item.minecraft.flower_banner_pattern": "Karoga raksts",
  "item.minecraft.flower_banner_pattern.desc": "Zieds",
  "item.minecraft.flower_banner_pattern.new": "Zieda karoga raksts",
  "item.minecraft.flower_pot": "Puķupods",
  "item.minecraft.fox_spawn_egg": "Lapsas radīšanas ola",
  "item.minecraft.friend_pottery_shard": "Drauga keramikas lauska",
  "item.minecraft.friend_pottery_sherd": "Drauga keramikas šķemba",
  "item.minecraft.frog_spawn_egg": "Vardes radīšanas ola",
  "item.minecraft.furnace_minecart": "Vagons ar krāsni",
  "item.minecraft.ghast_spawn_egg": "Ghast radīšanas ola",
  "item.minecraft.ghast_tear": "Ghast asara",
  "item.minecraft.glass_bottle": "Stikla pudele",
  "item.minecraft.glistering_melon_slice": "Mirdzoša arbūza šķēle",
  "item.minecraft.globe_banner_pattern": "Karoga raksts",
  "item.minecraft.globe_banner_pattern.desc": "Globuss",
  "item.minecraft.globe_banner_pattern.new": "Globusa karoga raksts",
  "item.minecraft.glow_berries": "Spīdošās ogas",
  "item.minecraft.glow_ink_sac": "Spīdošās tintes maisiņš",
  "item.minecraft.glow_item_frame": "Spīdošs priekšmetu rāmis",
  "item.minecraft.glow_squid_spawn_egg": "Spīdošā kalmāra radīšanas ola",
  "item.minecraft.glowstone_dust": "Mirdzakmens putekļi",
  "item.minecraft.goat_horn": "Kazas taure",
  "item.minecraft.goat_spawn_egg": "Kazas radīšanas ola",
  "item.minecraft.gold_ingot": "Zelta stienis",
  "item.minecraft.gold_nugget": "Zelta gabals",
  "item.minecraft.golden_apple": "Zelta ābols",
  "item.minecraft.golden_axe": "Zelta cirvis",
  "item.minecraft.golden_boots": "Zelta zābaki",
  "item.minecraft.golden_carrot": "Zelta burkāns",
  "item.minecraft.golden_chestplate": "Zelta bruņas",
  "item.minecraft.golden_helmet": "Zelta ķivere",
  "item.minecraft.golden_hoe": "Zelta kaplis",
  "item.minecraft.golden_horse_armor": "Zelta zirgu bruņas",
  "item.minecraft.golden_leggings": "Zelta bikses",
  "item.minecraft.golden_nautilus_armor": "Zelta Nautila Bruņas",
  "item.minecraft.golden_pickaxe": "Zelta cirtnis",
  "item.minecraft.golden_shovel": "Zelta lāpsta",
  "item.minecraft.golden_spear": "Zelta Šķēps",
  "item.minecraft.golden_sword": "Zelta zobens",
  "item.minecraft.gray_bundle": "Pelēks saišķis",
  "item.minecraft.gray_dye": "Pelēka krāsviela",
  "item.minecraft.gray_harness": "Pelēks iejūgs",
  "item.minecraft.green_bundle": "Zaļš saišķis",
  "item.minecraft.green_dye": "Zaļa krāsa",
  "item.minecraft.green_harness": "Zaļš iejūgs",
  "item.minecraft.guardian_spawn_egg": "Sarga radīšanas ola",
  "item.minecraft.gunpowder": "Šaujampulveris",
  "item.minecraft.guster_banner_pattern": "Karoga raksts",
  "item.minecraft.guster_banner_pattern.desc": "Brāzma",
  "item.minecraft.guster_banner_pattern.new": "Brāzmas karoga raksts",
  "item.minecraft.guster_pottery_sherd": "Brāzmas keramikas šķemba",
  "item.minecraft.happy_ghast_spawn_egg": "Priecīgā Ghast radīšanas ola",
  "item.minecraft.harness": "Iejūgs",
  "item.minecraft.heart_of_the_sea": "Jūras sirds",
  "item.minecraft.heart_pottery_shard": "Sirds keramikas lasuka",
  "item.minecraft.heart_pottery_sherd": "Sirds keramikas šķemba",
  "item.minecraft.heartbreak_pottery_shard": "Lauztas sirds keramikas lauska",
  "item.minecraft.heartbreak_pottery_sherd": "Lauztas sirds keramikas šķemba",
  "item.minecraft.hoglin_spawn_egg": "Hoglina radīšanas ola",
  "item.minecraft.honey_bottle": "Medus pudele",
  "item.minecraft.honeycomb": "Medus šūna",
  "item.minecraft.hopper_minecart": "Vagons ar piltuvi",
  "item.minecraft.horse_spawn_egg": "Zirga radīšanas ola",
  "item.minecraft.host_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.host_armor_trim_smithing_template.new": "Host Armor Trim",
  "item.minecraft.howl_pottery_shard": "Kauciena keramikas lauska",
  "item.minecraft.howl_pottery_sherd": "Kauciena keramikas šķemba",
  "item.minecraft.husk_spawn_egg": "Huska radīšanas ola",
  "item.minecraft.ink_sac": "Tintes maisiņš",
  "item.minecraft.iron_axe": "Dzelzs cirvis",
  "item.minecraft.iron_boots": "Dzelzs zābaki",
  "item.minecraft.iron_chestplate": "Dzelzs bruņas",
  "item.minecraft.iron_golem_spawn_egg": "Dzelzs golema radīšanas ola",
  "item.minecraft.iron_helmet": "Dzelzs ķivere",
  "item.minecraft.iron_hoe": "Dzelzs kaplis",
  "item.minecraft.iron_horse_armor": "Dzelzs zirgu bruņas",
  "item.minecraft.iron_ingot": "Dzelzs stienis",
  "item.minecraft.iron_leggings": "Dzelzs bikses",
  "item.minecraft.iron_nautilus_armor": "Dzelzs Nautila Bruņas",
  "item.minecraft.iron_nugget": "Dzelzs gabals",
  "item.minecraft.iron_pickaxe": "Dzelzs cirtnis",
  "item.minecraft.iron_shovel": "Dzelzs lāpsta",
  "item.minecraft.iron_spear": "Dzelzs Šķēps",
  "item.minecraft.iron_sword": "Dzelzs zobens",
  "item.minecraft.item_frame": "Priekšmetu rāmis",
  "item.minecraft.jungle_boat": "Džungļu koka laiva",
  "item.minecraft.jungle_chest_boat": "Džungļu koka laiva ar lādi",
  "item.minecraft.knowledge_book": "Zināšanu grāmata",
  "item.minecraft.lapis_lazuli": "Lazurīts",
  "item.minecraft.lava_bucket": "Lavas spainis",
  "item.minecraft.lead": "Pavada",
  "item.minecraft.leather": "Āda",
  "item.minecraft.leather_boots": "Adas zābaki",
  "item.minecraft.leather_chestplate": "Ādas jaka",
  "item.minecraft.leather_helmet": "Ādas cepure",
  "item.minecraft.leather_horse_armor": "Ādas zirgu bruņas",
  "item.minecraft.leather_leggings": "Ādas bikses",
  "item.minecraft.light_blue_bundle": "Gaiši zils saišķis",
  "item.minecraft.light_blue_dye": "Gaiši zila krāsa",
  "item.minecraft.light_blue_harness": "Gaiši zils iejūgs",
  "item.minecraft.light_gray_bundle": "Gaiši pelēks saišķis",
  "item.minecraft.light_gray_dye": "Gaiši pelēka krāsa",
  "item.minecraft.light_gray_harness": "Gaiši pelēks iejūgs",
  "item.minecraft.lime_bundle": "Gaiši zaļš saišķis",
  "item.minecraft.lime_dye": "Gaiši zaļa krāsa",
  "item.minecraft.lime_harness": "Gaiši zaļš iejūgs",
  "item.minecraft.lingering_potion": "Ilgstošā dzira",
  "item.minecraft.lingering_potion.effect.awkward": "Neveikla ilgstoša dzira",
  "item.minecraft.lingering_potion.effect.empty": "Ilgstoša neuztaisāma dzira",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Ilgstoša uguns noturības dzira",
  "item.minecraft.lingering_potion.effect.harming": "Ilgstoša kaitēšanas dzira",
  "item.minecraft.lingering_potion.effect.healing": "Ilgstoša veselības dzira",
  "item.minecraft.lingering_potion.effect.infested": "Ilgstoša infestācijas dzira",
  "item.minecraft.lingering_potion.effect.invisibility": "Ilgstoša neredzamības dzira",
  "item.minecraft.lingering_potion.effect.leaping": "Ilgstoša lēkšanas dzira",
  "item.minecraft.lingering_potion.effect.levitation": "Ilgstoša levitēšanas dzira",
  "item.minecraft.lingering_potion.effect.luck": "īlgstošā veiksmes dzira",
  "item.minecraft.lingering_potion.effect.mundane": "Inkdienišķa ilgstošā dzira",
  "item.minecraft.lingering_potion.effect.night_vision": "Ilgstoša nakts redzamības dzira",
  "item.minecraft.lingering_potion.effect.oozing": "Ilgstoša izplūšanas dzira",
  "item.minecraft.lingering_potion.effect.poison": "Ilgstoša Indes dzira",
  "item.minecraft.lingering_potion.effect.regeneration": "Ilgstoša reģenerācijas dzira",
  "item.minecraft.lingering_potion.effect.slow_falling": "Ilgstošā lēnās krišanas dzira",
  "item.minecraft.lingering_potion.effect.slowness": "Ilgstoša Lēnuma Dzira",
  "item.minecraft.lingering_potion.effect.strength": "Ilgstoša Stipruma Dzira",
  "item.minecraft.lingering_potion.effect.swiftness": "Ilgstoša Ātruma Dzira",
  "item.minecraft.lingering_potion.effect.thick": "Bieza ilgstoša Dzira",
  "item.minecraft.lingering_potion.effect.turtle_master": "Ilgstošā Bruņurupuča Meistara Dzira",
  "item.minecraft.lingering_potion.effect.water": "Ilgstoša Ūdens Pudele",
  "item.minecraft.lingering_potion.effect.water_breathing": "Ilgstoša zemūdens elpošanas dzira",
  "item.minecraft.lingering_potion.effect.weakness": "Ilgstoša reģenerācijas dzira",
  "item.minecraft.lingering_potion.effect.weaving": "Ilgstoša aušanas dzira",
  "item.minecraft.lingering_potion.effect.wind_charged": "Ilgstoša vēja uzlādes dzira",
  "item.minecraft.llama_spawn_egg": "Lamas radīšanas ola",
  "item.minecraft.lodestone_compass": "Dzīslakmens kompass",
  "item.minecraft.mace": "Vāle",
  "item.minecraft.magenta_bundle": "Fuksīns saišķis",
  "item.minecraft.magenta_dye": "Fuksīna krāsa",
  "item.minecraft.magenta_harness": "Fuksīns iejūgs",
  "item.minecraft.magma_cream": "Magmas krēms",
  "item.minecraft.magma_cube_spawn_egg": "Magmas kuba radīšanas ola",
  "item.minecraft.mangrove_boat": "Mangroves laiva",
  "item.minecraft.mangrove_chest_boat": "Mangroves laiva ar lādi",
  "item.minecraft.map": "Tukša karte",
  "item.minecraft.melon_seeds": "Arbūza sēklas",
  "item.minecraft.melon_slice": "Arbūza šķēle",
  "item.minecraft.milk_bucket": "Piena spainis",
  "item.minecraft.minecart": "Vagons",
  "item.minecraft.miner_pottery_shard": "Racēja keramikas lasuka",
  "item.minecraft.miner_pottery_sherd": "Racēja keramikas šķemba",
  "item.minecraft.mojang_banner_pattern": "Karoga raksts",
  "item.minecraft.mojang_banner_pattern.desc": "Lieta",
  "item.minecraft.mojang_banner_pattern.new": "Lietas karoga raksts",
  "item.minecraft.mooshroom_spawn_egg": "Mooshroom radīšanas ola",
  "item.minecraft.mourner_pottery_shard": "Sērotāja keramikas lauska",
  "item.minecraft.mourner_pottery_sherd": "Sērotāja keramikas šķemba",
  "item.minecraft.mule_spawn_egg": "Mūļa radīšanas ola",
  "item.minecraft.mushroom_stew": "Sēņu zupa",
  "item.minecraft.music_disc_11": "Mūzikas disks",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "Mūzikas plate",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "Mūzikas disks",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "Mūzikas disks",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "Mūzikas disks",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "Mūzikas disks",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "Mūzikas plate",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "Mūzikas plate",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator (Mūzikas kaste)",
  "item.minecraft.music_disc_far": "Mūzikas disks",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "Mūzikas Disks",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "Mūzikas disks",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "Mūzikas disks",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "Mūzikas disks",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "Mūzikas disks",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "Mūzikas plate",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "Mūzikas disks",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - relikvija",
  "item.minecraft.music_disc_stal": "Mūzikas disks",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "Mūzikas disks",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "Mūzikas Disks",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "Mūzikas disks",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "Mūzikas disks",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "Jēla aitas gaļa",
  "item.minecraft.name_tag": "Birka",
  "item.minecraft.nautilus_shell": "Nautilus čaula",
  "item.minecraft.nautilus_spawn_egg": "Nautila Radīšanas Ola",
  "item.minecraft.nether_brick": "Nether ķieģeļi",
  "item.minecraft.nether_star": "Nether zvaigzne",
  "item.minecraft.nether_wart": "Nether kārpa",
  "item.minecraft.netherite_axe": "Nezerīta cirvis",
  "item.minecraft.netherite_boots": "Nezerīta zābaki",
  "item.minecraft.netherite_chestplate": "Nezerīta bruņas",
  "item.minecraft.netherite_helmet": "Nezerīta ķivere",
  "item.minecraft.netherite_hoe": "Nezerīta kaplis",
  "item.minecraft.netherite_horse_armor": "Nezerīta Zirga Bruņas",
  "item.minecraft.netherite_ingot": "Nezerīta stienis",
  "item.minecraft.netherite_leggings": "Nezerīta bikses",
  "item.minecraft.netherite_nautilus_armor": "Nezerīta Nautila Bruņas",
  "item.minecraft.netherite_pickaxe": "Nezerīta cirtnis",
  "item.minecraft.netherite_scrap": "Nezerīta druska",
  "item.minecraft.netherite_shovel": "Nezerīta lāpsta",
  "item.minecraft.netherite_spear": "Nezerīta Šķēps",
  "item.minecraft.netherite_sword": "Nezerīta zobens",
  "item.minecraft.netherite_upgrade_smithing_template": "Kalēja veidne",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Nezerīta uzlabojums",
  "item.minecraft.oak_boat": "Ozola laiva",
  "item.minecraft.oak_chest_boat": "Ozola laiva ar lādi",
  "item.minecraft.ocelot_spawn_egg": "Ocelota radīšanas ola",
  "item.minecraft.ominous_bottle": "Draudīga pudele",
  "item.minecraft.ominous_trial_key": "Draudīga izaicinājuma atslēga",
  "item.minecraft.orange_bundle": "Oranžs saišķis",
  "item.minecraft.orange_dye": "Oranža krāsa",
  "item.minecraft.orange_harness": "Oranžs iejūgs",
  "item.minecraft.painting": "Glezna",
  "item.minecraft.pale_oak_boat": "Bālā ozola laiva",
  "item.minecraft.pale_oak_chest_boat": "Bālā ozola laiva ar lādi",
  "item.minecraft.panda_spawn_egg": "Pandas radīšanas ola",
  "item.minecraft.paper": "Papīrs",
  "item.minecraft.parched_spawn_egg": "Izkaltušā Radīšanas Ola",
  "item.minecraft.parrot_spawn_egg": "Papagaiļa radīšanas ola",
  "item.minecraft.phantom_membrane": "Fantoma membrāna",
  "item.minecraft.phantom_spawn_egg": "Fantoma radīšanas ola",
  "item.minecraft.pig_spawn_egg": "Cūkas radīšanas ola",
  "item.minecraft.piglin_banner_pattern": "Karoga raksts",
  "item.minecraft.piglin_banner_pattern.desc": "Šņukurs",
  "item.minecraft.piglin_banner_pattern.new": "Snuķa karoga raksts",
  "item.minecraft.piglin_brute_spawn_egg": "Brutālā piglina radīšanas ola",
  "item.minecraft.piglin_spawn_egg": "Piglina radīšanas ola",
  "item.minecraft.pillager_spawn_egg": "Laupītāja radīšanas ola",
  "item.minecraft.pink_bundle": "Rozā saišķis",
  "item.minecraft.pink_dye": "Rozā krāsa",
  "item.minecraft.pink_harness": "Rozā iejūgs",
  "item.minecraft.pitcher_plant": "Nepente",
  "item.minecraft.pitcher_pod": "Nepentes pāksts",
  "item.minecraft.plenty_pottery_shard": "Pārticības keramikas lauska",
  "item.minecraft.plenty_pottery_sherd": "Pārticības keramikas šķemba",
  "item.minecraft.poisonous_potato": "Indīgs kartupelis",
  "item.minecraft.polar_bear_spawn_egg": "Polārlāča radīšanas ola",
  "item.minecraft.popped_chorus_fruit": "Kausēts kora auglis",
  "item.minecraft.porkchop": "Jēla cūkgaļa",
  "item.minecraft.potato": "Kartupelis",
  "item.minecraft.potion": "Dzira",
  "item.minecraft.potion.effect.awkward": "Neveikla dzira",
  "item.minecraft.potion.effect.empty": "Neizveidojama dzira",
  "item.minecraft.potion.effect.fire_resistance": "Uguns noturības dzira",
  "item.minecraft.potion.effect.harming": "Kaitēšanas dzira",
  "item.minecraft.potion.effect.healing": "Veselības dzira",
  "item.minecraft.potion.effect.infested": "Infestācijas dzira",
  "item.minecraft.potion.effect.invisibility": "Neredzamības dzira",
  "item.minecraft.potion.effect.leaping": "Augstlēkšanas dzira",
  "item.minecraft.potion.effect.levitation": "Levitāciajs dzira",
  "item.minecraft.potion.effect.luck": "Veiksmes dzira",
  "item.minecraft.potion.effect.mundane": "Ikdienišķa dzira",
  "item.minecraft.potion.effect.night_vision": "Nakts redzamības dzira",
  "item.minecraft.potion.effect.oozing": "Izplūšanas dzira",
  "item.minecraft.potion.effect.poison": "Indes dzira",
  "item.minecraft.potion.effect.regeneration": "Reģenerācijas dzira",
  "item.minecraft.potion.effect.slow_falling": "Lēnās krišanas dzira",
  "item.minecraft.potion.effect.slowness": "Lēnuma dzira",
  "item.minecraft.potion.effect.strength": "Spēka dzira",
  "item.minecraft.potion.effect.swiftness": "Ātruma dzira",
  "item.minecraft.potion.effect.thick": "Bieza dzira",
  "item.minecraft.potion.effect.turtle_master": "Bruņurupuču Meistara Dzira",
  "item.minecraft.potion.effect.water": "Ūdens pudele",
  "item.minecraft.potion.effect.water_breathing": "Zemūdens elpošanas dzira",
  "item.minecraft.potion.effect.weakness": "Vājuma dzira",
  "item.minecraft.potion.effect.weaving": "Aušanas dzira",
  "item.minecraft.potion.effect.wind_charged": "Vēja uzlādes dzira",
  "item.minecraft.pottery_shard_archer": "Strēlnieka keramikas lauska",
  "item.minecraft.pottery_shard_arms_up": "Paceltu roku keramikas lauska",
  "item.minecraft.pottery_shard_prize": "Balvas keramikas lauska",
  "item.minecraft.pottery_shard_skull": "Galvaskausa keramikas lauska",
  "item.minecraft.powder_snow_bucket": "Drupena sniega spainis",
  "item.minecraft.prismarine_crystals": "Prizmarīna kristāli",
  "item.minecraft.prismarine_shard": "Prizmarīna lauska",
  "item.minecraft.prize_pottery_shard": "Balvas keramikas lauska",
  "item.minecraft.prize_pottery_sherd": "Balvas keramikas šķemba",
  "item.minecraft.pufferfish": "Pūšļa zivs",
  "item.minecraft.pufferfish_bucket": "Pūšļa zivs spainis",
  "item.minecraft.pufferfish_spawn_egg": "Pūšļa zivs radīšanas ola",
  "item.minecraft.pumpkin_pie": "Ķirbju pīrāgs",
  "item.minecraft.pumpkin_seeds": "Ķirbju sēklas",
  "item.minecraft.purple_bundle": "Violets saišķis",
  "item.minecraft.purple_dye": "Violeta krāsa",
  "item.minecraft.purple_harness": "Violets iejūgs",
  "item.minecraft.quartz": "Nether kvarcs",
  "item.minecraft.rabbit": "Jēla truša gaļa",
  "item.minecraft.rabbit_foot": "Truša kāja",
  "item.minecraft.rabbit_hide": "Truša āda",
  "item.minecraft.rabbit_spawn_egg": "Truša radīšanas ola",
  "item.minecraft.rabbit_stew": "Truša zupa",
  "item.minecraft.raiser_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Pacēlāja bruņu ornaments",
  "item.minecraft.ravager_spawn_egg": "Postītāja radīšanas ola",
  "item.minecraft.raw_copper": "Neapstrādāts varš",
  "item.minecraft.raw_gold": "Neapstrādāts zelts",
  "item.minecraft.raw_iron": "Neapstrādāts dzelzs",
  "item.minecraft.recovery_compass": "Atgūšanas kompass",
  "item.minecraft.red_bundle": "Sarkans saišķis",
  "item.minecraft.red_dye": "Sarkana krāsa",
  "item.minecraft.red_harness": "Sarkans iejūgs",
  "item.minecraft.redstone": "Redstone putekļi",
  "item.minecraft.resin_brick": "Sveķu ķieģelis",
  "item.minecraft.resin_clump": "Sveķu pika",
  "item.minecraft.rib_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Ribu bruņu ornaments",
  "item.minecraft.rotten_flesh": "Sapuvusi gaļa",
  "item.minecraft.saddle": "Segli",
  "item.minecraft.salmon": "Jēls lasis",
  "item.minecraft.salmon_bucket": "Laša spainis",
  "item.minecraft.salmon_spawn_egg": "Laša radīšanas ola",
  "item.minecraft.scrape_pottery_sherd": "Skrāpēšanas keramikas šķemba",
  "item.minecraft.scute": "Čaula",
  "item.minecraft.sentry_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Aizsarga bruņu ornaments",
  "item.minecraft.shaper_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Veidotāja bruņu apdare",
  "item.minecraft.sheaf_pottery_shard": "Kūļa keramikas lauska",
  "item.minecraft.sheaf_pottery_sherd": "Kūļa keramikas šķemba",
  "item.minecraft.shears": "Šķēres",
  "item.minecraft.sheep_spawn_egg": "Aitas radīšanas ola",
  "item.minecraft.shelter_pottery_shard": "Patvēruma keramikas lauska",
  "item.minecraft.shelter_pottery_sherd": "Patvēruma keramikas šķemba",
  "item.minecraft.shield": "Vairogs",
  "item.minecraft.shield.black": "Melns vairogs",
  "item.minecraft.shield.blue": "Zils vairogs",
  "item.minecraft.shield.brown": "Brūns vairogs",
  "item.minecraft.shield.cyan": "Ciāns vairogs",
  "item.minecraft.shield.gray": "Pelēks vairogs",
  "item.minecraft.shield.green": "Zaļš vairogs",
  "item.minecraft.shield.light_blue": "Gaiši zils vairogs",
  "item.minecraft.shield.light_gray": "Gaiši pelēks vairogs",
  "item.minecraft.shield.lime": "Gaiši zaļš vairogs",
  "item.minecraft.shield.magenta": "Fuksīns vairogs",
  "item.minecraft.shield.orange": "Oranžs vairogs",
  "item.minecraft.shield.pink": "Rozā vairogs",
  "item.minecraft.shield.purple": "Violets vairogs",
  "item.minecraft.shield.red": "Sarkans vairogs",
  "item.minecraft.shield.white": "Balts vairogs",
  "item.minecraft.shield.yellow": "Dzeltens vairogs",
  "item.minecraft.shulker_shell": "Shulker čaula",
  "item.minecraft.shulker_spawn_egg": "Shulker radīšanas ola",
  "item.minecraft.sign": "Zīme",
  "item.minecraft.silence_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Klusuma bruņu ornaments",
  "item.minecraft.silverfish_spawn_egg": "Sudrabzivs radīšanas ola",
  "item.minecraft.skeleton_horse_spawn_egg": "Zirga skeleta radīšanas ola",
  "item.minecraft.skeleton_spawn_egg": "Skeleta radīšanas ola",
  "item.minecraft.skull_banner_pattern": "Karoga raksts",
  "item.minecraft.skull_banner_pattern.desc": "Galvaskauss",
  "item.minecraft.skull_banner_pattern.new": "Galvaskausa karoga raksts",
  "item.minecraft.skull_pottery_shard": "Galvaskausa keramikas lauska",
  "item.minecraft.skull_pottery_sherd": "Galvaskausa keramikas šķemba",
  "item.minecraft.slime_ball": "Gļotu bumba",
  "item.minecraft.slime_spawn_egg": "Gļotu radīšanas ola",
  "item.minecraft.smithing_template": "Kalšanas veidne",
  "item.minecraft.smithing_template.applies_to": "Attiecas uz:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Pievienot stieni vai kristālu",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Bruņas",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Pievienot bruņu gabalu",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Stieņi & kristāli",
  "item.minecraft.smithing_template.ingredients": "Sastāvdaļas:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Pievienot nezerīta stieni",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Dimanta piederumi",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Pievienot dimanta bruņas, ieroci vai instrumentu",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Nezerīta stienis",
  "item.minecraft.smithing_template.upgrade": "Uzlabojums: ",
  "item.minecraft.sniffer_spawn_egg": "Ošņātāja radīšanas ola",
  "item.minecraft.snort_pottery_shard": "Šņaucēja keramikas lauska",
  "item.minecraft.snort_pottery_sherd": "Šņaucēja keramikas šķemba",
  "item.minecraft.snout_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Snuķa bruņu ornaments",
  "item.minecraft.snow_golem_spawn_egg": "Sniega golema radīšanas ola",
  "item.minecraft.snowball": "Sniega pika",
  "item.minecraft.spectral_arrow": "Spektrālā bulta",
  "item.minecraft.spider_eye": "Zirnekļa acs",
  "item.minecraft.spider_spawn_egg": "Zirnekļa radīšanas ola",
  "item.minecraft.spire_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Smailes bruņu ornaments",
  "item.minecraft.splash_potion": "Metamā dzira",
  "item.minecraft.splash_potion.effect.awkward": "Neveikla šļakstoša dzira",
  "item.minecraft.splash_potion.effect.empty": "Šļakstoša, neizveidojama dzira",
  "item.minecraft.splash_potion.effect.fire_resistance": "Šļakstoša uguns noturības dzira",
  "item.minecraft.splash_potion.effect.harming": "Šļakstoša kaitēšanas dzira",
  "item.minecraft.splash_potion.effect.healing": "Šļakstoša veselības dzira",
  "item.minecraft.splash_potion.effect.infested": "Šļakstoša infestācijas dzira",
  "item.minecraft.splash_potion.effect.invisibility": "Šļakstoša neredzamības dzira",
  "item.minecraft.splash_potion.effect.leaping": "Šļakstoša augstlēkšanas dzira",
  "item.minecraft.splash_potion.effect.levitation": "Šļakstoša levitācijas dzira",
  "item.minecraft.splash_potion.effect.luck": "Šļakstoša veiksmes dzira",
  "item.minecraft.splash_potion.effect.mundane": "Šļakstoša ikdienišķā dzira",
  "item.minecraft.splash_potion.effect.night_vision": "Šļakstoša nakts redzamības dzira",
  "item.minecraft.splash_potion.effect.oozing": "Šļakstoša izplūšanas dzira",
  "item.minecraft.splash_potion.effect.poison": "Šļakstoša indes dzira",
  "item.minecraft.splash_potion.effect.regeneration": "Šļakstoša reģenerācijas dzira",
  "item.minecraft.splash_potion.effect.slow_falling": "Šļakstoša lēnās krišanas dzira",
  "item.minecraft.splash_potion.effect.slowness": "Šļakstoša lēnuma dzira",
  "item.minecraft.splash_potion.effect.strength": "Šļakstoša spēka dzira",
  "item.minecraft.splash_potion.effect.swiftness": "Šļakstoša ātruma dzira",
  "item.minecraft.splash_potion.effect.thick": "Bieza šļakstoša dzira",
  "item.minecraft.splash_potion.effect.turtle_master": "Šļakstoša bruņurupuču meistara dzira",
  "item.minecraft.splash_potion.effect.water": "Šļakstoša ūdens pudele",
  "item.minecraft.splash_potion.effect.water_breathing": "Šļakstoša zemūdens elpošanas dzira",
  "item.minecraft.splash_potion.effect.weakness": "Šļakstoša vājuma dzira",
  "item.minecraft.splash_potion.effect.weaving": "Šļakstoša aušanas dzira",
  "item.minecraft.splash_potion.effect.wind_charged": "Šļakstoša vēja uzlādes dzira",
  "item.minecraft.spruce_boat": "Egles laiva",
  "item.minecraft.spruce_chest_boat": "Egles laiva ar lādi",
  "item.minecraft.spyglass": "Tālskatis",
  "item.minecraft.squid_spawn_egg": "Kalmāra radīšanas ola",
  "item.minecraft.stick": "Nūja",
  "item.minecraft.stone_axe": "Akmens cirvis",
  "item.minecraft.stone_hoe": "Akmens kaplis",
  "item.minecraft.stone_pickaxe": "Akmens cirtnis",
  "item.minecraft.stone_shovel": "Akmens lāpsta",
  "item.minecraft.stone_spear": "Akmens Šķēps",
  "item.minecraft.stone_sword": "Akmens zobens",
  "item.minecraft.stray_spawn_egg": "Klaidoņa radīšanas ola",
  "item.minecraft.strider_spawn_egg": "Lavas ceļotāja radīšanas ola",
  "item.minecraft.string": "Aukla",
  "item.minecraft.sugar": "Cukurs",
  "item.minecraft.suspicious_stew": "Aizdomīgs sautējums",
  "item.minecraft.sweet_berries": "Saldās ogas",
  "item.minecraft.tadpole_bucket": "Spainis ar kurkuļiem",
  "item.minecraft.tadpole_spawn_egg": "Kurkuļa radīšanas ola",
  "item.minecraft.tide_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Plūdmaiņas bruņu ornaments",
  "item.minecraft.tipped_arrow": "Uzlabota bulta",
  "item.minecraft.tipped_arrow.effect.awkward": "Uzlabota bulta",
  "item.minecraft.tipped_arrow.effect.empty": "Neizveidojama apcirsta bulta",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Uguns noturības bulta",
  "item.minecraft.tipped_arrow.effect.harming": "Kaitējuma bulta",
  "item.minecraft.tipped_arrow.effect.healing": "Veseļošanās bulta",
  "item.minecraft.tipped_arrow.effect.infested": "Infestācijas bulta",
  "item.minecraft.tipped_arrow.effect.invisibility": "Neredzamības bulta",
  "item.minecraft.tipped_arrow.effect.leaping": "Augstlēkšanas bulta",
  "item.minecraft.tipped_arrow.effect.levitation": "Levitācijas bulta",
  "item.minecraft.tipped_arrow.effect.luck": "Veiksmes bulta",
  "item.minecraft.tipped_arrow.effect.mundane": "Uzlabota bulta",
  "item.minecraft.tipped_arrow.effect.night_vision": "Nakts redzamības bulta",
  "item.minecraft.tipped_arrow.effect.oozing": "Izplūdes bulta",
  "item.minecraft.tipped_arrow.effect.poison": "Saindēta bulta",
  "item.minecraft.tipped_arrow.effect.regeneration": "Reģenerācijas bulta",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Lēnās krišanas bulta",
  "item.minecraft.tipped_arrow.effect.slowness": "Lēnuma bulta",
  "item.minecraft.tipped_arrow.effect.strength": "Spēka bulta",
  "item.minecraft.tipped_arrow.effect.swiftness": "Ātruma bulta",
  "item.minecraft.tipped_arrow.effect.thick": "Uzlabota bulta",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Bruņurupuču Meistara bulta",
  "item.minecraft.tipped_arrow.effect.water": "Šļakatas bulta",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Zemūdens elpošanas bulta",
  "item.minecraft.tipped_arrow.effect.weakness": "Vājuma bulta",
  "item.minecraft.tipped_arrow.effect.weaving": "Aušanas bulta",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Vēja lādiņa bulta",
  "item.minecraft.tnt_minecart": "Vagons ar dinamītu",
  "item.minecraft.torchflower_seeds": "Lāpu ziedu sēklas",
  "item.minecraft.totem_of_undying": "Nemirstības totēms",
  "item.minecraft.trader_llama_spawn_egg": "Tirgotāja lamas radīšanas ola",
  "item.minecraft.trial_key": "Izaicinājuma atslēga",
  "item.minecraft.trident": "Trijžuburis",
  "item.minecraft.tropical_fish": "Tropiskā zivs",
  "item.minecraft.tropical_fish_bucket": "Tropiskās zivs spainis",
  "item.minecraft.tropical_fish_spawn_egg": "Tropu zivs radīšanas ola",
  "item.minecraft.turtle_helmet": "Bruņurupuča čaula",
  "item.minecraft.turtle_scute": "Bruņurupuča čaula",
  "item.minecraft.turtle_spawn_egg": "Bruņurupuča radīšanas ola",
  "item.minecraft.vex_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Veksa bruņu ornaments",
  "item.minecraft.vex_spawn_egg": "Veksa radīšanas ola",
  "item.minecraft.villager_spawn_egg": "Ciema iedzīvotāja radīšanas ola",
  "item.minecraft.vindicator_spawn_egg": "Vindikatora radīšanas ola",
  "item.minecraft.wandering_trader_spawn_egg": "Klejojošā tirgotāja radīšanas ola",
  "item.minecraft.ward_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Uzrauga bruņu ornaments",
  "item.minecraft.warden_spawn_egg": "Uzrauga radīšanas ola",
  "item.minecraft.warped_fungus_on_a_stick": "Izlocīta sēnīte uz nūjas",
  "item.minecraft.water_bucket": "Ūdens spainis",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Ceļrāža bruņu ornaments",
  "item.minecraft.wheat": "Kvieši",
  "item.minecraft.wheat_seeds": "Kviešu sēklas",
  "item.minecraft.white_bundle": "Balts saišķis",
  "item.minecraft.white_dye": "Balta krāsa",
  "item.minecraft.white_harness": "Balts iejūgs",
  "item.minecraft.wild_armor_trim_smithing_template": "Kalēja veidne",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Savvaļas bruņu ornaments",
  "item.minecraft.wind_charge": "Vēja lādiņš",
  "item.minecraft.witch_spawn_egg": "Raganas radīšanas ola",
  "item.minecraft.wither_skeleton_spawn_egg": "Wither skeleta radīšanas ola",
  "item.minecraft.wither_spawn_egg": "Wither radīšanas ola",
  "item.minecraft.wolf_armor": "Vilka bruņas",
  "item.minecraft.wolf_spawn_egg": "Vilka radīšanas ola",
  "item.minecraft.wooden_axe": "Koka cirvis",
  "item.minecraft.wooden_hoe": "Koka kaplis",
  "item.minecraft.wooden_pickaxe": "Koka cirtnis",
  "item.minecraft.wooden_shovel": "Koka lāpsta",
  "item.minecraft.wooden_spear": "Koka Šķēps",
  "item.minecraft.wooden_sword": "Koka zobens",
  "item.minecraft.writable_book": "Grāmata un spalva",
  "item.minecraft.written_book": "Sarakstīta grāmata",
  "item.minecraft.yellow_bundle": "Dzeltens saišķis",
  "item.minecraft.yellow_dye": "Dzeltena krāsa",
  "item.minecraft.yellow_harness": "Dzeltens iejūgs",
  "item.minecraft.zoglin_spawn_egg": "Zoglina radīšanas ola",
  "item.minecraft.zombie_horse_spawn_egg": "Zombija zirga radīšanas ola",
  "item.minecraft.zombie_nautilus_spawn_egg": "Zombija Nautila Radīšanas Ola",
  "item.minecraft.zombie_spawn_egg": "Zombija radīšanas ola",
  "item.minecraft.zombie_villager_spawn_egg": "Zombija ciema iedzīvotāja radīšanas ola",
  "item.minecraft.zombified_piglin_spawn_egg": "Zombificēta piglina radīšanas ola"
}
export const lv_lv = items; 
